import _typeof from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _toConsumableArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.flat-map.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.sub.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getFunctionMenu, getChildFunctionMenu, getNotSupplier as _getNotSupplier, getNotBrand as _getNotBrand, getSpecialBrand as _getSpecialBrand, getScopeIndex as _getScopeIndex, getStandardIndex, saveCardRule, saveStandardCardRule, getOrderRule as _getOrderRule, checkEntityMenu, getCityTree, setWhiteCity as _setWhiteCity, getCinemaList, delCinema, addWhiteCinema as _addWhiteCinema, ordersTemplateDownload, upCinemaFile, confirmUpCinemaFile, getNotTags, cakeBrandList, setBlackCake as _setBlackCake, setCommonBlackCake, setOrderRule, getCheckedCityList as _getCheckedCityList, setCakeStoreDiscount as _setCakeStoreDiscount, setCakeStoreZydDiscount as _setCakeStoreZydDiscount, cakeCommonBrandList, getCakeHomeBrands, setCakeHomeBrands, saveGroupChildMenus, getZydBrands, getLvmamaKeyword as _getLvmamaKeyword, setLvmamaKeyword, getLogList, onlineOrderBrandList, setBlackOnlineOrder as _setBlackOnlineOrder, getCommonCakeHomeBrands as _getCommonCakeHomeBrands, setCommonCakeHomeBrands, getMovieKeyword as _getMovieKeyword, setMovieKeyword, getMovieZydBrands as _getMovieZydBrands, setMovieZydBrands as _setMovieZydBrands, delWhiteMovieList } from '@/api/order';
import { getOrderBaseInfo, updateOrderBaseInfo } from '@/views/cardSystem/saleToos/api';
import { getOrderRuleMenu as _getOrderRuleMenu, setOrderRuleMenu } from './api/index';
import copyOrderRuleDialog from './components/copyOrderRuleDialog.vue';
import setCommissionTypeDialog from './components/setCommissionTypeDialog.vue';
import cakeStoreConfig from './components/cakeStoreConfig.vue';
import cakeConfig from './components/cakeConfig.vue';
import onlineOrderConfig from './components/onlineOrderConfig.vue';
import movieConfig from './components/movieConfig.vue';
import lvmamaConfig from './components/lvmamaConfig.vue';
import uploadFile from '@/components/upload/uploadFile.vue';
import UpLoadFileDialog from '@/components/upload/upLoadFileDialog';
import DeliveryInfoForm from './components/DeliveryInfoForm.vue';
import GoodsVisibilityCheck from './components/goodsVisibilityCheck.vue';
import { parseTime } from '@/utils';
import { set } from 'js-cookie';
var DELIVERY_EMPTY = {
  customer_type: '',
  discount: '',
  service_cost: '',
  settlement_type: '',
  company_cost: '',
  diff_money: '',
  diff_remark: '',
  commission_type: '',
  the_loser_id: '',
  target_cost_rate: ''
};
export default {
  components: {
    uploadFile: uploadFile,
    UpLoadFileDialog: UpLoadFileDialog,
    DeliveryInfoForm: DeliveryInfoForm,
    copyOrderRuleDialog: copyOrderRuleDialog,
    cakeStoreConfig: cakeStoreConfig,
    cakeConfig: cakeConfig,
    onlineOrderConfig: onlineOrderConfig,
    movieConfig: movieConfig,
    lvmamaConfig: lvmamaConfig,
    setCommissionTypeDialog: setCommissionTypeDialog,
    GoodsVisibilityCheck: GoodsVisibilityCheck
  },
  props: {
    trendParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    orderInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    hideLogTab: {
      type: Boolean,
      default: false
    },
    cardRuleKind: {
      type: String,
      default: ''
    },
    // 报价单配置待办入口：交付信息不受订单列表权限点控制
    deliveryAuthFree: {
      type: Boolean,
      default: false
    },
    // 集采订单入口：仅展示交付信息
    onlyDelivery: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      deliveryForm: {},
      // 交付信息表单
      deliverySaving: false,
      deliveryLoading: false,
      cardBinGroupId: '',
      // 业务类型  9999为单独的vp审核跳转过来的只能查看
      menuSwitchDialog: false,
      dialogType: null,
      // 弹窗类型 1 自由兑 2 蛋糕到店 3 蛋糕到家 4 在线点单 5 电影自由兑 专为线上菜单id132设置 6 电影 7 景点门票
      time: Date.parse(new Date()),
      batchIds: [],
      // ids 订单列表批量设置订单规则 ids
      type: '',
      // 1 从卡类型管理进入 2 订单详情进入 3只可进入查看 4 电影次卡进入 9 礼包卡进入
      entryType: '',
      // 不同菜单跳转过来的区分参数  平台配置  渠道列表 管理中心 订单规则
      menuType: '',
      bin_id: '',
      menuDialog: false,
      notBrandDialog: false,
      supplierDialog: false,
      brandDialog: false,
      childMensDialog: false,
      whiteCityDialog: false,
      notTagDialog: false,
      // 黑名单标签弹框
      exportDialog: true,
      cakeDialog: false,
      cakeStoreDrawer: false,
      loading: false,
      discountDialog: false,
      integralDialog: false,
      integralMenuDialog: false,
      keywordBlackDialog: false,
      onlineOrderDialog: false,
      whiteMovieDialog: false,
      groupMenusDialog: false,
      // 组合子菜单弹框
      pages: {},
      pages1: {},
      // 影院白名单数据
      pages2: {},
      // 影院白名单数据
      searchBrand: {
        brand_name: '',
        page: 1,
        pagesize: 20
      },
      searchTags: {
        tag_name: '',
        ids: [],
        page: 1,
        pagesize: 20
      },
      searchCity: {
        page: 1,
        pagesize: 20
      },
      info: {},
      form: {
        is_recharge: 0,
        is_merge: 0,
        recharge_ratio: 1.0,
        note: '',
        open_wx_pay: 1,
        is_open_all_wx_pay: 0,
        max_goods_points: 0,
        is_programme_merge: 0,
        user_unbind: 0,
        background_image: '',
        other_max_goods_points: '',
        optional_mall_name: '',
        max_bind_num: '',
        optional_mall_commision: '',
        bin_id: '',
        online_note: '',
        card_desc: '',
        // 卡面展示信息
        integral_value_rate: '',
        is_open_integral_value: 0,
        single_face: null
      },
      img_url: '',
      // 临时背景图
      dialogSuppliers: [],
      // 弹框运营商数据
      checkedSupplier: [],
      // 默认选中运营商
      menuList: [],
      // 默认选中功能菜单
      copyMenuList: [],
      // 备份功能菜单
      dialogMenus: [],
      // 弹框菜单
      checkedGroupChildIds: [],
      // 选中的组合子菜单
      checkedChildIds: [],
      // 子菜单选中
      dialogNotBrands: [],
      // 弹框不支持的品牌
      dialogSpecialBrands: [],
      // 弹框特殊品牌
      notBrands: [],
      // 弹框选中临时不支持的品牌
      notTags: [],
      // 标签黑名单
      checkedNotBrands: [],
      // 默认选中不支持的品牌
      specialsBrands: [],
      // 弹框选中临时不支持的特殊品牌
      checkedSpecialBrands: [],
      // 默认选中的特殊品牌
      package_views: [],
      // 余额展示数据
      childMenus: [],
      // 子功能菜单
      groupChildMenus: [],
      // 组合子功能菜单
      showGoodsName: false,
      // 礼包自选商城名称展示状态
      create_commission: 0,
      // 订单是否以达成 1 达成
      cityTree: [],
      // 白名单城市树
      tempCity: [],
      // 白名单城市树
      checkedCity: [],
      tagList: [],
      // 标签黑名单列表
      newTree: [],
      cinemaList: [],
      whiteCinemaList: [],
      // allCinema: [], // 搜索展示所有数据
      cityList: [],
      tempTags: [],
      // 临时tags
      tempCakes: [],
      cakeList: [],
      // 蛋糕列表
      checkedCakes: [],
      // 选中得蛋糕列表
      city: '',
      uploadFiledDialogShow: false,
      // 导入礼包信息dialog
      dialogFileTitle: '',
      // 导入礼包信息dialog title
      demoTitle: '',
      upTitle: '',
      packageFile: '',
      // 上次礼包文件,
      errorFileUrl: '',
      // 查看错误文件
      tipsTitle: '',
      modal_key: '',
      menuIndex: 0,
      // 选中的功能菜单index
      order_id: '',
      ruleType: '',
      goodsVisibilityVisible: false,
      goodsVisibilityCategoryId: '',
      city_id: [],
      searchForm: {
        city_id: '',
        // cinema_id: '',
        cinema_name: '',
        status: '',
        start_discount: '',
        end_discount: '',
        order_id: '',
        rule_id: ''
      },
      cinemaPage1: {
        page: 1,
        pagesize: 20
      },
      cinemaPage2: {
        page: 1,
        pagesize: 20
      },
      linkUrl: {
        config: '/package/banner/upload/config',
        extensions: '/package/banner/upload/file-allow-extensions'
      },
      ruleInfo: {},
      // 基本规则信息
      offRules: [{
        lable: '线下蛋糕',
        val: '1'
      }, {
        lable: '线下电影',
        val: '2'
      }],
      integralForm: {
        integral_value_unit: '',
        integral_value_rate: '',
        is_open_integral_value: 0
      },
      isShowIntegral: 0,
      select_code: [],
      category_id: '',
      menus_alias: [],
      discountItem: {},
      discountTabsVal: 'cake_store',
      // 品牌黑名单tab切换
      showDiscountTabs: false,
      checkedCityList: [],
      menuItem: {},
      // 积分价值 菜单点击的那一项
      menu_integral_value: null,
      whiteCityType: '',
      //城市白名单类型 cake:蛋糕 movie:电影
      checkedCinema: [],
      checkedWhiteCinema: [],
      keyword: '',
      keywordArr: [],
      showLog: false,
      logTableData: [],
      parseTime: parseTime,
      logPage: {
        page: 1,
        page_size: 20,
        totalCount: 0
      },
      whiteCityTitle: '',
      currentRowMenu: {},
      onlineOrderList: [],
      checkedOnlineOrder: [],
      tempOnlineOrder: [],
      gift_menus: [],
      integralType: '',
      integralIndex: null,
      saveConfigFlag: false,
      // true为已经是个性化规则 功能菜单操作无需在走页面大保存
      commonDiscount: '',
      movieZydDialog: false,
      // 电影自由兑品牌黑名单弹框
      movieZydList: [],
      checkedMovieZydList: [],
      tempMovieZyd: [],
      is_show: '',
      // 菜单展示/隐藏
      isShowIndex: null,
      movie_white_list_type: null,
      // 1:影院白名单   2:城市白名单 0 为未设置白名单
      configType: 'menu',
      menusInfo: {},
      queryData: {},
      // 作为组件使用传递来的参数 || 作为页面使用 路由中携带参数
      cakeStoreType: '',
      checkedCityTotal: 0,
      whiteCinemaTotal: 0,
      cakeWhiteTotal: 0,
      // 子组件中操作功能类型。
      // 蛋糕：viewCakeChild - 查看，setCakeChild - 设置；
      // 在线点单：viewFoodChild - 查看，setFoodChild - 设置；
      // 景区门票：viewLvmamaChild - 查看子菜单，setLvmamaChild - 设置子菜单； viewLvmamaKeyword - 查看关键词黑名单，setLvmamaKeyword - 设置关键词黑名单；
      // 电影：viewMovieKeyword - 查看关键词黑名单，setMovieKeyword - 设置关键词黑名单；viewWhiteMovie - 查看城市/影院白名单，setWhiteMovie - 设置城市/影院白名单
      childMenuType: '',
      menuForm: {
        format_menus: 1,
        category_name: '',
        category_alias_name: '',
        id: ''
      },
      selectedMenu: [],
      checkedMenuIds: [],
      platform_menu: [],
      channel_common: [],
      channel_special: [],
      promotion_special: [],
      promotion_general: [],
      firstSelectMenuFlag: true,
      // 第一次打开菜单弹框的状态
      originalSelectMenu: [],
      // 初次进入订单规则 已选菜单的数据
      commissionConfig: {}
    };
  },
  watch: {
    menuList: function menuList(newVal, oldVal) {
      this.showGoodsName = newVal.some(function (e) {
        return e.id === 4;
      });
    }
  },
  created: function created() {
    if (Object.keys(this.trendParams).length > 0) {
      this.queryData = this.trendParams;
    } else {
      this.queryData = this.$route.query;
    }
    var _this$queryData = this.queryData,
      cardBinGroupId = _this$queryData.cardBinGroupId,
      _this$queryData$ids = _this$queryData.ids,
      ids = _this$queryData$ids === void 0 ? '[]' : _this$queryData$ids,
      type = _this$queryData.type,
      entryType = _this$queryData.entryType,
      menuType = _this$queryData.menuType,
      bin_id = _this$queryData.bin_id,
      order_id = _this$queryData.order_id,
      flag = _this$queryData.flag,
      configType = _this$queryData.configType;
    this.cardBinGroupId = cardBinGroupId;
    this.batchIds = Array.isArray(ids) ? ids : JSON.parse(ids);
    this.type = parseInt(type);
    this.entryType = entryType;
    this.menuType = menuType;
    this.bin_id = bin_id;
    this.order_id = order_id;
    this.ruleType = flag;
    this.searchForm.order_id = order_id;
    this.configType = this.onlyDelivery ? 'delivery' : configType == 'rule' ? 'rule' : 'menu';
    if (this.onlyDelivery) {
      // 集采入口只拉取交付信息，规则相关接口不请求
      this.fetchDeliveryInfo();
      return;
    }
    this.loading = true;
    if (this.ruleType === 'cardType') {
      this.getScopeIndex();
    } else {
      // 订单进入需要调订单的接口
      this.getSpecialBrand();
      this.getOrderRule();
    }
    this.getOrderRuleMenu();
  },
  methods: {
    // 打开商品可见性校验抽屉
    openGoodsVisibility: function openGoodsVisibility(row) {
      this.goodsVisibilityCategoryId = row.id;
      this.goodsVisibilityVisible = true;
    },
    syncCustomerList: function syncCustomerList(props) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var cb;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              cb = props.cb;
              _context.n = 1;
              return _this.setOrderRuleMenu(false, false);
            case 1:
              cb && cb();
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    refreshOrderRule: function refreshOrderRule() {
      if (this.ruleType === 'cardType') {
        this.getScopeIndex();
      } else {
        // 订单进入需要调订单的接口
        this.getSpecialBrand();
        this.getOrderRule();
      }
      this.getOrderRuleMenu();
    },
    onSuccess: function onSuccess() {
      if (Object.keys(this.trendParams).length > 0) {
        this.$emit('onSuccess');
      } else {
        this.$router.back();
      }
    },
    getOrderRuleMenu: function getOrderRuleMenu() {
      var _this2 = this;
      _getOrderRuleMenu({
        order_id: this.ruleType === 'cardType' ? 0 : this.order_id,
        binid: this.bin_id
      }, this.ruleType, this.entryType).then(function (res) {
        res.data.menus.forEach(function (e) {
          if (e.group_type == 1) {
            e.group_type_text = '单一类型';
          } else {
            e.group_type_text = '组合类型';
            e.sub_categorys.forEach(function (el, ids) {
              el.parentId = e.id;
            });
          }
        });
        res.data.copy_cake_store_discount = res.data.cake_store_discount;
        if (_this2.ruleType === 'order') {
          res.data.menus.forEach(function (e, index) {
            e.sub_categorys.forEach(function (el, ids) {
              el.parentId = e.id;
              el.isChild = true;
              el.alias_name = el.category_name_gxh;
            });
            e.isEdit = false;
            var match = res.data.menus_alias && res.data.menus_alias.length ? res.data.menus_alias.find(function (el) {
              return el.id == e.id;
            }) : [];
            e.alias_name = match ? match.name : '';
          });
        }
        _this2.copyMenuList = JSON.parse(JSON.stringify(res.data.menus ? res.data.menus : []));
        _this2.menus_alias = res.data.menus_alias ? res.data.menus_alias : [];
        _this2.checkedNotBrands = res.data.not_brands ? res.data.not_brands : [];
        _this2.movie_white_list_type = res.data.movie_white_list_type;
        _this2.menuList = res.data.menus ? res.data.menus : [];
        _this2.checkedSupplier = res.data.not_suppliers ? res.data.not_suppliers : [];
        _this2.notTags = res.data.not_tags.length ? res.data.not_tags : [];
        if (res.data.special_brands) {
          res.data.special_brands.forEach(function (el) {
            el.brand_name = el.name;
          });
        }
        _this2.checkedSpecialBrands = res.data.special_brands ? res.data.special_brands : [];
        _this2.menusInfo = res.data;
      });
    },
    tabChange: function tabChange(type) {
      if (type == 'log') {
        this.viewLog(1);
      }
      if (type == 'delivery') {
        this.fetchDeliveryInfo();
      }
    },
    // 获取交付信息回显：接口值优先，缺省回落到空表单
    fetchDeliveryInfo: function fetchDeliveryInfo() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, baseInfo, form;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (_this3.order_id) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              _this3.deliveryLoading = true;
              _context2.p = 2;
              _context2.n = 3;
              return getOrderBaseInfo({
                order_id: _this3.order_id
              });
            case 3:
              res = _context2.v;
              baseInfo = res && res.data || {};
              form = _objectSpread({}, DELIVERY_EMPTY);
              Object.keys(form).forEach(function (key) {
                var val = baseInfo[key];
                if (val !== undefined && val !== null && val !== '') {
                  form[key] = val;
                }
              });
              _this3.deliveryForm = form;
            case 4:
              _context2.p = 4;
              _this3.deliveryLoading = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, null, [[2,, 4, 5]]);
      }))();
    },
    // 保存交付信息
    saveDeliveryInfo: function saveDeliveryInfo(form) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _this4.deliverySaving = true;
              _context3.p = 1;
              _context3.n = 2;
              return updateOrderBaseInfo(_objectSpread({
                order_id: _this4.order_id
              }, form));
            case 2:
              _this4.$message.success('保存成功');
              _this4.$emit('deliverySaved');
              _this4.fetchDeliveryInfo();
            case 3:
              _context3.p = 3;
              _this4.deliverySaving = false;
              return _context3.f(3);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, null, [[1,, 3, 4]]);
      }))();
    },
    viewLog: function viewLog() {
      var _this5 = this;
      var currentPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.logPage.page = currentPage;
      var _this$logPage = this.logPage,
        page = _this$logPage.page,
        page_size = _this$logPage.page_size;
      getLogList(_objectSpread(_objectSpread({}, this.menuType == 'orderDetails' || this.menuType == 'platformQueryManage' || this.menuType == 'serviceCenter' ? {
        order_id: this.order_id
      } : {
        bin_id: this.bin_id
      }), {}, {
        page: page,
        page_size: page_size
      }), this.menuType).then(function (res) {
        var _res$data = res.data,
          data = _res$data === void 0 ? [] : _res$data,
          _res$pages = res.pages,
          pages = _res$pages === void 0 ? {} : _res$pages;
        _this5.logTableData = data;
        _this5.logPage.totalCount = pages.totalCount;
        _this5.showLog = true;
      });
    },
    getOrderRule: function getOrderRule() {
      var _this6 = this;
      _getOrderRule({
        order_id: this.order_id
      }, this.entryType).then(function (res) {
        _this6.commissionConfig = res.data;
        _this6.loading = false;
        _this6.integralForm.is_open_integral_value = res.data.rule.is_open_integral_value;
        _this6.integralForm.integral_value_unit = res.data.rule.integral_value_unit ? res.data.rule.integral_value_unit : '积分';
        _this6.integralForm.integral_value_rate = res.data.rule.integral_value_rate;
        _this6.isShowIntegral = res.data.rule.is_open_integral_value;
        _this6.ruleInfo = res.data.rule;
        _this6.create_commission = res.data.create_commission;
        _this6.package_views = res.data.rule.package_view_type ? res.data.rule.package_view_type : [];
        if (res.data.rule.recharge_ratio) {
          _this6.form = res.data.rule;
          _this6.$set(_this6.form, 'single_face', res.data.rule.programme_info.single_face);
        }
        if (_this6.ruleType === 'order') {
          _this6.gift_menus = res.data.rule.gift_menus ? res.data.rule.gift_menus : [];
        }
        // 礼包卡进入
        if (_this6.cardBinGroupId == 3) {
          _this6.package_views.forEach(function (el) {
            if (el.is_select) {
              _this6.form.package_view_type = el.id;
            }
          });
        }
        _this6.form.bin_id = res.data.rule.bin_id;
        if (res.data.rule.background_image) {
          _this6.img_url = res.data.rule.background_image;
        }
      });
    },
    // 保存规则
    saveAliasName: function saveAliasName(row) {
      this.menus_alias.forEach(function (e) {
        if (e.id == row.id) {
          e.name = row.alias_name;
        }
      });
      row.isEdit = false;
    },
    submitCardRule: function submitCardRule() {
      var _this7 = this;
      var isSuccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      if (this.cardBinGroupId == 4 && this.form.other_max_goods_points <= 0 && !this.menuList.every(function (e) {
        return e.type == 'movie';
      }) && this.configType == 'menu') {
        this.$message.warning('请先配置积分价值,再添加功能菜单');
        return false;
      }
      if (this.configType == 'menu') {
        this.setOrderRuleMenu(isSuccess);
        return false;
      }
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          var params = _objectSpread({}, _this7.form);
          delete params.gift_menus;
          delete params.custom_cat;
          delete params.menus;
          delete params.menus_alias;
          delete params.not_brands;
          delete params.not_suppliers;
          delete params.not_keywords;
          delete params.not_tags;
          delete params.special_menus;
          delete params.is_integral_menus;
          if (_this7.batchIds && _this7.batchIds.length) {
            params.order_id = _this7.batchIds.length ? _this7.batchIds : _this7.order_id;
          } else {
            params.order_id = _this7.ruleType == 'order' ? _this7.order_id : 0;
          }
          if (_this7.cardBinGroupId != 3) {
            params.package_view_type = '';
          }
          if (params.background_image.indexOf(_this7.$ossurl) === 0) {
            params.background_image = params.background_image.replace(_this7.$ossurl, '');
          }
          if (_this7.ruleType === 'cardType' && _this7.batchIds.length === 0) {
            _this7.loading = true;
            if (_this7.menuType == 'standardCardType') {
              saveStandardCardRule(params).then(function () {
                _this7.loading = false;
                _this7.$message({
                  type: 'success',
                  message: '规则配置成功!'
                });
                if (isSuccess) {
                  _this7.onSuccess();
                } else {
                  _this7.getOrderRuleMenu();
                }
              }).catch(function () {
                _this7.loading = false;
              });
            } else {
              saveCardRule(params).then(function () {
                _this7.loading = false;
                _this7.$message({
                  type: 'success',
                  message: '规则配置成功!'
                });
                if (isSuccess) {
                  _this7.onSuccess();
                } else {
                  _this7.getOrderRuleMenu();
                }
              }).catch(function () {
                _this7.loading = false;
              });
            }
          } else {
            if (_this7.queryData.premium_price && _this7.queryData.premium_price !== '0.00' && _this7.cardBinGroupId == 3) {
              _this7.$confirm('<span style="color: red">礼包存在溢价，请注意非常规礼包佣金比例是否正确再保存！</span>', '礼包溢价提醒', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                dangerouslyUseHTMLString: true,
                type: 'warning'
              }).then(function () {
                _this7.loading = true;
                setOrderRule(params).then(function () {
                  _this7.loading = false;
                  _this7.$message({
                    type: 'success',
                    message: '规则配置成功!'
                  });
                  if (isSuccess) {
                    _this7.onSuccess();
                  } else {
                    _this7.getOrderRuleMenu();
                  }
                }).catch(function () {
                  _this7.loading = false;
                });
              });
            } else {
              _this7.loading = true;
              setOrderRule(params).then(function () {
                _this7.loading = false;
                _this7.$message({
                  type: 'success',
                  message: '规则配置成功!'
                });
                if (isSuccess) {
                  _this7.onSuccess();
                } else {
                  _this7.getOrderRuleMenu();
                }
              }).catch(function () {
                _this7.loading = false;
              });
            }
          }
        } else {
          return false;
        }
      });
    },
    setOrderRuleMenu: function setOrderRuleMenu(flag) {
      var _this8 = this;
      var showMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var menus = [];
      var checkedSupplier = [];
      var checkedNotBrands = [];
      var custom_cat = [];
      var rule_menu = [];
      var special_brands = [];
      var group_data = [];
      this.gift_menus.forEach(function (el) {
        rule_menu.push({
          id: el.id,
          is_integral_value: el.is_integral_value
        });
      });
      this.menuList.forEach(function (el) {
        if (el.group_type == 1) {
          // 积分价值
          rule_menu.push({
            id: el.id,
            is_integral_value: el.is_integral_value,
            is_show: el.is_show
          });
          menus.push(el.id);
        } else {
          group_data.push({
            categtory_id: el.id,
            menus: el.sub_categorys.map(function (item) {
              return item.id;
            })
          });
          menus.push(el.id);
          el.sub_categorys.forEach(function (e) {
            rule_menu.push({
              id: e.id,
              is_integral_value: e.is_integral_value,
              is_show: e.is_show
            });
            e.childrens.forEach(function (e) {
              if (e.selected) {
                custom_cat.push(e.id);
              }
            });
            menus.push(e.id);
          });
        }
        el.childrens.forEach(function (e) {
          if (e.selected) {
            custom_cat.push(e.id);
          }
        });
      });
      // return false
      this.checkedSupplier.forEach(function (el) {
        checkedSupplier.push(el.id);
      });
      this.checkedNotBrands.forEach(function (el) {
        checkedNotBrands.push(el.id);
      });
      this.checkedSpecialBrands.forEach(function (el) {
        special_brands.push(el.id);
      });
      var alias = this.menuList.map(function (e) {
        return {
          id: e.id,
          name: e.alias_name
        };
      });
      var params = {
        bin_id: this.bin_id,
        special_menus: [],
        menus: menus.length ? menus : null,
        rule_menu: rule_menu.length ? rule_menu : null,
        not_suppliers: checkedSupplier.length ? checkedSupplier : null,
        not_brands: checkedNotBrands.length ? checkedNotBrands : null,
        custom_cat: custom_cat,
        not_tags: this.notTags.length ? this.notTags.map(function (item) {
          return item.id;
        }) : null,
        special_brands: special_brands.length ? special_brands : null,
        menus_alias: alias && alias.length ? alias : null,
        group_data: JSON.stringify(group_data)
      };
      if (this.batchIds && this.batchIds.length) {
        params.order_id = this.batchIds.length ? this.batchIds : this.order_id;
      } else {
        params.order_id = this.ruleType == 'order' ? this.order_id : 0;
      }
      // 检查是否存在新加入的第三方资源菜单
      var needSettlementDialog = false;
      var selectMenuIds = new Set(this.originalSelectMenu.map(function (item) {
        return item.id;
      }));
      var newAddMenus = this.selectedMenu.filter(function (item) {
        return !selectMenuIds.has(item.id);
      });
      if (newAddMenus.length) {
        needSettlementDialog = newAddMenus.some(function (e) {
          return e.category_business_type == 8;
        }) && this.commissionConfig.is_change_settle == 1;
      }
      // 溢价提醒
      var needPremiumConfirm = this.queryData.premium_price && this.queryData.premium_price !== '0.00' && this.cardBinGroupId == 3;
      var proceed = function proceed() {
        // 第三方资源菜单并且佣金核算方式=自动核算 或 人工已核算 才弹框
        if (needSettlementDialog && _this8.commissionConfig.commission_type != 1) {
          _this8._settlementParams = params;
          var event = _this8.$refs.settlementType;
          event.commissionTypeDialog = true;
          event.order_id = _this8.order_id;
          event.flag = flag;
        } else {
          return _this8._doSave(params, flag, showMsg);
        }
      };
      if (needPremiumConfirm) {
        return this.$confirm('<span style="color: red">礼包存在溢价，请注意非常规礼包佣金比例是否正确再保存！</span>', '礼包溢价提醒', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true,
          type: 'warning'
        }).then(proceed);
      } else {
        return proceed();
      }
    },
    // 调用保存规则菜单接口
    _doSave: function _doSave(params, flag, showMsg) {
      var _this9 = this;
      this.loading = true;
      return new Promise(function (resolve, reject) {
        setOrderRuleMenu(params, _this9.batchIds.length ? 'order' : _this9.ruleType).then(function () {
          _this9.loading = false;
          resolve(true);
          showMsg && _this9.$message.success('规则配置成功!');
          if (flag) {
            _this9.onSuccess();
          } else {
            _this9.getOrderRuleMenu();
          }
        }).catch(function (err) {
          _this9.loading = false;
          reject(err);
        });
      });
    },
    upSettlementTypeSuccess: function upSettlementTypeSuccess(flag) {
      var params = this._settlementParams;
      if (params) {
        this._settlementParams = null;
        this._doSave(params, flag, true);
      } else if (flag) {
        this.onSuccess();
      } else {
        this.getOrderRuleMenu();
      }
    },
    // 渲染图片 赋值
    emitUploadFile: function emitUploadFile(val, tempImg) {
      this.img_url = tempImg;
      this.form.background_image = val;
    },
    // 获取公共规则配置
    getScopeIndex: function getScopeIndex() {
      var _this0 = this;
      if (this.menuType == 'standardCardType') {
        getStandardIndex({
          binid: this.order_id
        }).then(function (res) {
          _this0.loading = false;
          _this0.setData(res);
        });
      } else {
        _getScopeIndex({
          binid: this.order_id
        }).then(function (res) {
          _this0.loading = false;
          _this0.setData(res);
        });
      }
    },
    setData: function setData(res) {
      var _this1 = this;
      this.integralForm.is_open_integral_value = res.data.is_open_integral_value;
      this.integralForm.integral_value_unit = res.data.integral_value_unit ? res.data.integral_value_unit : '积分';
      this.integralForm.integral_value_rate = res.data.integral_value_rate;
      this.isShowIntegral = res.data.is_open_integral_value;
      this.ruleInfo = res.data;
      if (res.data.recharge_ratio) {
        this.form = res.data;
      }
      this.form.bin_id = res.data.bin_id;
      this.package_views = res.data.package_view_type ? res.data.package_view_type : [];
      if (res.data.background_image) {
        this.img_url = res.data.background_image;
      }
      this.package_menus;
      if (this.cardBinGroupId == 3) {
        this.package_views.forEach(function (el) {
          if (el.is_select) {
            _this1.form.package_view_type = el.id;
          }
        });
      }
    },
    // 打开菜单弹框
    openMenuDialog: function openMenuDialog() {
      var _this10 = this;
      var ids = [];
      this.menuList.forEach(function (el) {
        ids.push(el.id);
      });
      this.menuForm = {
        format_menus: 1,
        category_name: '',
        category_alias_name: '',
        id: ''
      };
      getFunctionMenu(_objectSpread({
        ids: ids,
        bin_id: this.bin_id,
        order_id: this.ruleType == 'order' ? this.order_id : 0
      }, this.menuForm)).then(function (res) {
        if (_this10.firstSelectMenuFlag) {
          _this10.originalSelectMenu = _toConsumableArray(res.data.select);
          _this10.firstSelectMenuFlag = false;
        }
        _this10.selectedMenu = res.data.select;
        _this10.platform_menu = _this10.publicMenuFn(res.data.platform);
        _this10.channel_common = _this10.publicMenuFn(res.data.personalized_general);
        _this10.channel_special = _this10.publicMenuFn(res.data.personalized_special);
        _this10.promotion_special = _this10.publicMenuFn(res.data.promotion_special || []);
        _this10.promotion_general = _this10.publicMenuFn(res.data.promotion_general || []);
        _this10.initCheckedMenuIds();
        _this10.menuDialog = true;
      });
    },
    searchMenuList: function searchMenuList() {
      var _this11 = this;
      var ids = [];
      this.menuList.forEach(function (el) {
        ids.push(el.id);
      });
      getFunctionMenu(_objectSpread({
        ids: ids,
        bin_id: this.bin_id,
        order_id: this.ruleType == 'order' ? this.order_id : 0
      }, this.menuForm)).then(function (res) {
        _this11.platform_menu = _this11.publicMenuFn(res.data.platform);
        _this11.channel_common = _this11.publicMenuFn(res.data.personalized_general);
        _this11.channel_special = _this11.publicMenuFn(res.data.personalized_special);
        _this11.promotion_special = _this11.publicMenuFn(res.data.promotion_special || []);
        _this11.promotion_general = _this11.publicMenuFn(res.data.promotion_general || []);
        var allMenus = [].concat(_toConsumableArray(_this11.platform_menu), _toConsumableArray(_this11.channel_common), _toConsumableArray(_this11.channel_special), _toConsumableArray(_this11.promotion_special), _toConsumableArray(_this11.promotion_general));
        allMenus.forEach(function (item) {
          item.selected = _this11.checkedMenuIds.includes(item.id) ? 1 : 0;
        });
        _this11.updateSelectedMenu();
      });
    },
    //菜单公共处理方法-原处理逻辑
    publicMenuFn: function publicMenuFn(data) {
      data.forEach(function (e) {
        if (e.group_type == 2) {
          e.group_type_text = '组合类型';
          e.sub_categorys.forEach(function (el) {
            el.is_integral_value = 0;
            el.parentId = e.id;
          });
        } else {
          e.group_type_text = '单一类型';
        }
      });
      for (var i = 0; i < data.length; i++) {
        if (this.entryType != 'orderManage') {
          if (data[i].selected == 0 && data[i].use_range == 2) {
            data.splice(i, 1);
            i--;
          }
        }
        if (data[i].selected != 1) {
          data[i].is_integral_value = '0';
        }
        data[i].isEdit = false;
        var match = this.menuList.find(function (el) {
          return el.id == data[i].id;
        });
        data[i].alias_name = match ? match.alias_name : data[i].category_name_gxh;
        data[i].is_integral_value = match ? match.is_integral_value : '0';
      }
      var list = [];
      if (this.cardBinGroupId === 4) {
        data.forEach(function (e, index) {
          if (e.id === 2 || e.id === 30 || e.id === 7 || e.id === 15 || e.type === 'entity' || e.type === 'new_entity' || e.type === 'movie_offline_zyd' || e.type === 'cake' || e.type === 'new_cake' || e.type === 'cake_store' || e.type === 'vipcard' || e.type === 'code' || e.type === 'online_order' || e.type === 'composite') {
            list.push(e);
          }
        });
      }
      return list.length ? list : data;
    },
    // 菜单弹框确认
    confirmMenu: function confirmMenu() {
      var _this12 = this;
      var menusId = [];
      this.selectedMenu.forEach(function (el) {
        menusId.push(el.id);
      });
      if (this.ruleType === 'order' && this.cardBinGroupId == 3) {
        checkEntityMenu({
          order_id: this.order_id,
          menus: menusId
        }).then(function (res) {
          if (res.data) {
            _this12.$confirm('商城售价低于礼包售价，请谨慎选择！', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              _this12.fileterMenus();
            }).catch(function () {
              _this12.menuDialog = false;
              return false;
            });
          } else {
            _this12.fileterMenus();
          }
        });
      } else {
        this.fileterMenus();
      }
    },
    fileterMenus: function fileterMenus() {
      var _this13 = this;
      this.selectedMenu.forEach(function (e) {
        if (!_this13.isCheckedMenu(e.id)) {
          _this13.menuList.push(_objectSpread(_objectSpread({}, e), {}, {
            is_show: 1
          }));
        }
      });
      this.menuDialog = false;
      for (var i = this.menuList.length - 1; i >= 0; i--) {
        var isInSelected = this.selectedMenu.some(function (el) {
          return el.id == _this13.menuList[i].id;
        });
        if (!isInSelected) {
          this.menuList.splice(i, 1);
        } else {
          this.menuList[i].sub_categorys.forEach(function (el) {
            el.isChild = true;
            el.alias_name = el.category_name_gxh;
          });
        }
      }
    },
    // 判断弹框添加功能菜单是否存在
    isCheckedMenu: function isCheckedMenu(id) {
      return this.menuList.some(function (item) {
        return item.id == id;
      });
    },
    // 设置子菜单
    setChildMenu: function setChildMenu(childrens, row) {
      var _this14 = this;
      var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var _props$openType = props.openType,
        openType = _props$openType === void 0 ? '' : _props$openType;
      this.childMenuType = openType;
      this.currentRowMenu = row;
      this.checkedChildIds = [];
      childrens.forEach(function (e) {
        if (e.selected) {
          _this14.checkedChildIds.push(e.id);
        }
      });
      this.childMensDialog = true;
      this.childMenus = childrens;
    },
    // 设置子菜单，由于添加了组合菜单下标变化组合子菜单下标同父级菜单下标一样往下排0123
    setCheckedMenu: function setCheckedMenu() {
      var _this15 = this;
      if (this.currentRowMenu.parentId) {
        var parentIndex = this.menuList.findIndex(function (item) {
          return item.id == _this15.currentRowMenu.parentId;
        });
        var index = this.menuList[parentIndex].sub_categorys.findIndex(function (item) {
          return item.id == _this15.currentRowMenu.id;
        });
        // checkedChildIds为选中子菜单，需要把未选中的置0(子菜单页面红色)
        var result = this.menuList[parentIndex].sub_categorys[index].childrens.filter(function (item) {
          return !_this15.checkedChildIds.includes(item.id);
        });
        var result1 = this.menuList[parentIndex].sub_categorys[index].childrens.filter(function (item) {
          return _this15.checkedChildIds.includes(item.id);
        });
        result.forEach(function (e) {
          e.selected = 0;
        });
        result1.forEach(function (e) {
          e.selected = 1;
        });
        this.currentRowMenu = this.menuList[parentIndex].sub_categorys[index];
      } else {
        // var index = this.menuList.indexOf(this.currentRowMenu)
        var _index = this.menuList.findIndex(function (i) {
          return i.id === _this15.currentRowMenu.id;
        });
        // 常规菜单处理
        // checkedChildIds为选中子菜单，需要把未选中的置0(子菜单页面红色)
        var _result = this.menuList[_index].childrens.filter(function (item) {
          return !_this15.checkedChildIds.includes(item.id);
        });
        var _result2 = this.menuList[_index].childrens.filter(function (item) {
          return _this15.checkedChildIds.includes(item.id);
        });
        _result.forEach(function (e) {
          e.selected = 0;
        });
        _result2.forEach(function (e) {
          e.selected = 1;
        });
        this.currentRowMenu = this.menuList[_index];
      }
      this.childMensDialog = false;
      if (['setCakeChild', 'setLvmamaChild', 'setFoodChild'].includes(this.childMenuType)) {
        this.submitCardRule(false); // 蛋糕 景区门票类型组件内部设置子菜单后立即生效
      }
    },
    // 删除功能菜单
    delMenu: function delMenu(row) {
      // 组合菜单  子菜单删除
      if (row.parentId) {
        var parentIndex = this.menuList.findIndex(function (item) {
          return item.id == row.parentId;
        });
        var index = this.menuList[parentIndex].sub_categorys.findIndex(function (item) {
          return item.id == row.id;
        });
        this.menuList[parentIndex].sub_categorys.splice(index, 1);
      } else {
        this.menuList.splice(this.menuList.indexOf(row), 1);
      }
    },
    // 切换功能菜单
    selectMenu: function selectMenu(item, flag) {
      var _this16 = this;
      if (flag == 1) {
        item.selected = !item.selected;
        var idx = this.checkedMenuIds.indexOf(item.id);
        if (item.selected) {
          if (idx === -1) {
            this.checkedMenuIds.push(item.id);
          }
        } else {
          if (idx > -1) {
            this.checkedMenuIds.splice(idx, 1);
          }
        }
        this.updateSelectedMenu();
      } else {
        var menuslist = [];
        var allMenus = [].concat(_toConsumableArray(this.platform_menu), _toConsumableArray(this.channel_common), _toConsumableArray(this.channel_special), _toConsumableArray(this.promotion_special), _toConsumableArray(this.promotion_general));
        allMenus.forEach(function (el) {
          if (el.selected) {
            menuslist.push(el);
            if (el.group_type == 2) {
              var newitem = _this16.menuList.find(function (i) {
                return i.id == el.id;
              });
              if (newitem && newitem.id) {
                menuslist = menuslist.concat(newitem.sub_categorys);
              } else {
                menuslist = menuslist.concat(el.sub_categorys);
              }
            }
          }
        });
        if (item.group_type == 1) {
          menuslist.push(item);
        } else {
          menuslist = menuslist.concat(item.sub_categorys);
        }
        if (!this.checkSameMenuId(menuslist)) {
          return false;
        }
        item.selected = !item.selected;
      }
      this.updateSelectedMenu();
    },
    onMenuCheckChange: function onMenuCheckChange(val) {
      var _this17 = this;
      var allMenus = [].concat(_toConsumableArray(this.platform_menu), _toConsumableArray(this.channel_common), _toConsumableArray(this.channel_special), _toConsumableArray(this.promotion_special), _toConsumableArray(this.promotion_general));
      var allMenuIds = allMenus.map(function (item) {
        return item.id;
      });
      var preservedIds = this.selectedMenu.filter(function (item) {
        return !allMenuIds.includes(item.id);
      }).map(function (item) {
        return item.id;
      });
      preservedIds.forEach(function (id) {
        if (!_this17.checkedMenuIds.includes(id)) {
          _this17.checkedMenuIds.push(id);
        }
      });
      var oldIds = this.selectedMenu.map(function (item) {
        return item.id;
      });
      var newIds = val.filter(function (id) {
        return !oldIds.includes(id);
      });
      var removeIdSet = new Set();
      var messages = [];
      newIds.forEach(function (newId) {
        _this17.selectedMenu.forEach(function (menu) {
          if (menu.sub_categorys_count > 0 && menu.sub_categorys && menu.sub_categorys.length) {
            var found = menu.sub_categorys.find(function (sub) {
              return sub.id == newId;
            });
            if (found) {
              removeIdSet.add(newId);
              messages.push("\u6DFB\u52A0\u5931\u8D25\uFF0C\u3010(".concat(menu.id, ")").concat(menu.category_name, "\u3011\u4E0B\u5DF2\u7ECF\u5305\u542B\u3010(").concat(found.id, ")").concat(found.category_name, "\u3011"));
            }
          }
        });
        var newItem = allMenus.find(function (item) {
          return item.id == newId;
        });
        if (newItem && newItem.sub_categorys_count > 0 && newItem.sub_categorys && newItem.sub_categorys.length) {
          var existSubs = newItem.sub_categorys.filter(function (sub) {
            return _this17.selectedMenu.find(function (menu) {
              return menu.id == sub.id;
            });
          });
          if (existSubs.length > 0) {
            removeIdSet.add(newId);
            var subNames = existSubs.map(function (sub) {
              return "\u3010(".concat(sub.id, ")").concat(sub.category_name, "\u3011");
            }).join('、');
            messages.push("\u6DFB\u52A0\u5931\u8D25\uFF0C\u3010(".concat(newItem.id, ")").concat(newItem.category_name, "\u3011\u4E0B\u7684").concat(subNames, "\u5DF2\u7ECF\u88AB\u9009\u4E2D"));
          }
        }
      });
      if (removeIdSet.size > 0) {
        removeIdSet.forEach(function (removeId) {
          var idx = _this17.checkedMenuIds.indexOf(removeId);
          if (idx > -1) {
            _this17.checkedMenuIds.splice(idx, 1);
          }
        });
        this.$message.warning(messages.join('；'));
        allMenus.forEach(function (item) {
          item.selected = _this17.checkedMenuIds.includes(item.id) ? 1 : 0;
        });
        this.updateSelectedMenu();
        return;
      }
      allMenus.forEach(function (item) {
        item.selected = _this17.checkedMenuIds.includes(item.id) ? 1 : 0;
      });
      this.updateSelectedMenu();
    },
    updateSelectedMenu: function updateSelectedMenu() {
      var _this18 = this;
      var allMenus = [].concat(_toConsumableArray(this.platform_menu), _toConsumableArray(this.channel_common), _toConsumableArray(this.channel_special), _toConsumableArray(this.promotion_special), _toConsumableArray(this.promotion_general));
      var allMenuIds = allMenus.map(function (item) {
        return item.id;
      });
      var filteredSelected = allMenus.filter(function (item) {
        return _this18.checkedMenuIds.includes(item.id);
      });
      var preservedSelected = this.selectedMenu.filter(function (item) {
        return _this18.checkedMenuIds.includes(item.id) && !allMenuIds.includes(item.id);
      });
      this.selectedMenu = [].concat(_toConsumableArray(preservedSelected), _toConsumableArray(filteredSelected));
    },
    initCheckedMenuIds: function initCheckedMenuIds() {
      var allMenus = [].concat(_toConsumableArray(this.platform_menu), _toConsumableArray(this.channel_common), _toConsumableArray(this.channel_special), _toConsumableArray(this.promotion_special), _toConsumableArray(this.promotion_general));
      this.checkedMenuIds = allMenus.filter(function (item) {
        return item.selected;
      }).map(function (item) {
        return item.id;
      });
    },
    checkSameMenuId: function checkSameMenuId(allMenu) {
      // 使用reduce来统计每个id出现的次数
      var idCount = allMenu.reduce(function (acc, item) {
        acc[item.id] = (acc[item.id] || 0) + 1;
        return acc;
      }, {});

      // 找出出现次数大于1的id对应的对象，每个id只取一个
      var duplicateItems = allMenu.filter(function (item, index, array) {
        return idCount[item.id] > 1 && array.findIndex(function (x) {
          return x.id == item.id;
        }) == index;
      });
      var sameMenu = [];
      duplicateItems.forEach(function (e) {
        sameMenu.push("(".concat(e.id, ")").concat(e.category_name));
      });
      if (duplicateItems.length) {
        this.$message({
          message: sameMenu.toString() + ' 的单一类型已存在，无法添加',
          type: 'warning',
          duration: 5000
        });
        return false;
      } else {
        return true;
      }
    },
    // 获取不支持的品牌
    getNotBrand: function getNotBrand() {
      var _this19 = this;
      var ids = [];
      this.checkedNotBrands.forEach(function (el) {
        ids.push(el.id);
      });
      _getNotBrand(_objectSpread({
        ids: ids
      }, this.searchBrand)).then(function (res) {
        _this19.notBrandDialog = true;
        _this19.dialogNotBrands = res.data;
        _this19.pages = res.pages;
      });
    },
    // 获取特殊品牌
    getSpecialBrand: function getSpecialBrand() {
      var _this20 = this;
      _getSpecialBrand().then(function (res) {
        res.data.forEach(function (el) {
          el.checked = el.selected;
        });
        _this20.brandList = res.data;
      });
    },
    // 搜索品牌
    handleSearchBrand: function handleSearchBrand() {
      this.searchBrand.page = 1;
      this.searchBrand.pagesize = 20;
      this.getNotBrand();
    },
    // 特殊品牌选择change
    handleSelectChange: function handleSelectChange(val) {
      this.specialsBrands = val;
    },
    // 不支持的品牌changge事件
    handleSelectNotBrand: function handleSelectNotBrand(val) {
      this.notBrands = val;
    },
    handleSelectNotTags: function handleSelectNotTags(val) {
      this.tempTags = val;
    },
    handleSelectCake: function handleSelectCake(val) {
      this.tempCakes = val;
    },
    // 确认不支持的品牌弹框
    confirmNotBrandDialog: function confirmNotBrandDialog() {
      var _this$checkedNotBrand;
      this.notBrandDialog = false;
      this.notBrands.forEach(function (el) {
        el.name = el.brand_name;
      });
      (_this$checkedNotBrand = this.checkedNotBrands).push.apply(_this$checkedNotBrand, _toConsumableArray(this.notBrands));
      this.notBrands = [];
    },
    // 确认的特殊品牌
    confirmBrand: function confirmBrand() {
      this.checkedSpecialBrands = _toConsumableArray(this.specialsBrands);
      this.brandDialog = false;
    },
    delNotBrand: function delNotBrand(index) {
      this.checkedNotBrands.splice(index, 1);
    },
    // 删除特殊品牌
    delBrandTag: function delBrandTag(index) {
      this.checkedSpecialBrands.splice(index, 1);
    },
    openBrandDialog: function openBrandDialog(type) {
      var _this21 = this;
      if (type === '1') {
        this.brandDialog = true;
        var ids = [];
        if (this.checkedSpecialBrands) {
          this.checkedSpecialBrands.forEach(function (el) {
            ids.push(el.id);
          });
        }
        _getSpecialBrand({
          ids: ids
        }).then(function (res) {
          _this21.dialogSpecialBrands = res.data;
          _this21.$nextTick(function () {
            _this21.$refs.brandTable.clearSelection();
            res.data.forEach(function (e) {
              if (e.selected) {
                _this21.$nextTick(function () {
                  _this21.$refs.brandTable.toggleRowSelection(e, true);
                });
              }
            });
          });
        });
      } else {
        this.getNotBrand();
      }
    },
    checkboxChange: function checkboxChange(item) {
      item.selected = !item.selected;
    },
    // 获取不支持的供应商
    getNotSupplier: function getNotSupplier() {
      var _this22 = this;
      _getNotSupplier().then(function (res) {
        res.data.forEach(function (e) {
          e.checkedIds = [];
          e.list.forEach(function (el) {
            el.checked = el.selected;
            if (el.selected) {
              // 选择所有选中的供应商
              // this.checkedSupplier.push(el)
              // 渲染diolog 默认选择
              e.checkedIds.push(el.id);
            }
          });
        });
        _this22.dialogSuppliers = res.data;
      });
    },
    // 确定不支持的供应商
    confirmSupplier: function confirmSupplier() {
      var checkedBox = [];
      this.dialogSuppliers.forEach(function (e) {
        e.list.forEach(function (el) {
          if (el.selected) {
            checkedBox.push(el);
          }
        });
      });
      this.checkedSupplier = checkedBox;
      this.supplierDialog = false;
    },
    openSupplierDialog: function openSupplierDialog() {
      var _this23 = this;
      var ids = [];
      this.checkedSupplier.forEach(function (el) {
        ids.push(el.id);
      });
      _getNotSupplier({
        ids: ids
      }).then(function (res) {
        _this23.supplierDialog = true;
        res.data.forEach(function (e) {
          e.checkedIds = [];
          e.list.forEach(function (el) {
            el.checked = el.selected;
            if (el.selected) {
              // 选择所有选中的供应商
              // this.checkedSupplier.push(el)
              // 渲染diolog 默认选择
              e.checkedIds.push(el.id);
            }
          });
        });
        _this23.dialogSuppliers = res.data;
      });
    },
    openWhiteCity: function openWhiteCity(flag) {
      var _this24 = this;
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'movie';
      var row = arguments.length > 2 ? arguments[2] : undefined;
      if (this.batchIds.length) {
        this.$message.warning('批量修改订单暂不支持此操作');
        return false;
      }
      if (['setCakeWhite', 'viewCakeWhite'].includes(type)) {
        this.whiteCityTitle = '蛋糕城市白名单';
      } else if (['setFoodCity', 'viewFoodCity'].includes(type)) {
        this.whiteCityTitle = '在线点单城市黑名单';
      } else if (type == 'mt_daodian') {
        this.whiteCityTitle = "\u7F8E\u56E2\u5230\u5E97\u57CE\u5E02\u9ED1\u540D\u5355";
      } else if (type == 'mt_waimai') {
        this.whiteCityTitle = "\u7F8E\u56E2\u5916\u5356\u57CE\u5E02\u9ED1\u540D\u5355";
      } else if (type == 'ding_d') {
        this.whiteCityTitle = '叮咚买菜城市黑名单';
      } else if (type == 'yong_h') {
        this.whiteCityTitle = '永辉彩食鲜城市黑名单';
      } else if (type == 'sam') {
        this.whiteCityTitle = '山姆优选城市黑名单';
      } else if (type == 'xxcs') {
        this.whiteCityTitle = '小象超市城市黑名单';
      }
      if (row) {
        this.currentRowMenu = row;
      }
      // 蛋糕 & 电影 支持配置城市白名单
      this.whiteCityType = type;
      this.city = [];
      var params = {
        order_id: this.ruleType === 'cardType' ? 0 : this.order_id,
        rule_id: this.ruleType === 'cardType' ? this.ruleInfo.id : 0,
        menu_id: this.currentRowMenu.id
      };
      getCityTree(params, this.getEntryVal()).then(function (res) {
        _this24.cityTree = JSON.parse(JSON.stringify(res.data.tree));
        if (flag == 1) {
          _this24.select_code = res.data.select_code;
          _this24.delDisabledCity(res.data.tree);
          _this24.tempCity = res.data.tree;
        }
      });
      if (flag == 1) {
        this.whiteCityDialog = true;
        this.getCheckedCityList();
      }
    },
    getEntryVal: function getEntryVal() {
      var paramsType = '';
      var typeMap = {
        movie: 'movie',
        cake: 'cake',
        setCakeWhite: 'cake',
        viewCakeWhite: 'cake',
        online_order: {
          orderManage: 'orderManage',
          manageCenter: 'manageCenter',
          platformConfig: 'platformConfig',
          platformQueryManage: 'platformConfig',
          serviceCenter: 'platformConfig',
          channelManage: 'channelManage'
        },
        mt_daodian: {
          orderManage: 'orderManageMT',
          manageCenter: 'manageCenterMT',
          platformConfig: 'platformConfigMT',
          channelManage: 'channelManageMT'
        },
        mt_waimai: {
          orderManage: 'orderManageMTWM',
          manageCenter: 'manageCenterMTWM',
          platformConfig: 'platformConfigMTWM',
          channelManage: 'channelManageMTWM'
        },
        ding_d: {
          orderManage: 'orderManageDDMC',
          manageCenter: 'manageCenterDDMC',
          platformConfig: 'platformConfigDDMC',
          channelManage: 'channelManageDDMC'
        },
        yong_h: {
          orderManage: 'orderManageYH',
          manageCenter: 'manageCenterYH',
          platformConfig: 'platformConfigYH',
          channelManage: 'channelManageYH'
        },
        sam: {
          orderManage: 'orderManageSAM',
          manageCenter: 'manageCenterSAM',
          platformConfig: 'platformConfigSAM',
          channelManage: 'channelManageSAM'
        },
        xxcs: {
          orderManage: 'orderManageXXCS',
          manageCenter: 'manageCenterXXCS',
          platformConfig: 'platformConfigXXCS',
          channelManage: 'channelManageXXCS'
        }
      };
      typeMap.setFoodCity = typeMap.online_order;
      typeMap.viewFoodCity = typeMap.online_order;
      paramsType = typeMap[this.whiteCityType] ? _typeof(typeMap[this.whiteCityType]) === 'object' ? typeMap[this.whiteCityType][this.entryType] : typeMap[this.whiteCityType] : undefined;
      return paramsType;
    },
    getCheckedCityList: function getCheckedCityList() {
      var _this25 = this;
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _props$whiteCityType = props.whiteCityType,
        whiteCityType = _props$whiteCityType === void 0 ? '' : _props$whiteCityType;
      var params = _objectSpread({
        order_id: this.ruleType === 'cardType' ? 0 : this.order_id,
        rule_id: this.ruleType === 'cardType' ? this.ruleInfo.id : 0,
        menu_id: this.currentRowMenu.id
      }, this.searchCity);
      _getCheckedCityList(params, whiteCityType || this.getEntryVal()).then(function (res) {
        _this25.checkedCityList = res.data;
        _this25.pages = res.pages;
        _this25.checkedCityTotal = res.pages.totalCount || 0;
      });
    },
    delDisabledCity: function delDisabledCity(tree) {
      var _this26 = this;
      this.select_code.forEach(function (e) {
        tree.forEach(function (el, index) {
          if (e === el.value) {
            delete tree[index];
          } else {
            if (el.children && el.children.length) {
              _this26.delDisabledCity(el.children);
            }
          }
        });
      });
    },
    delCheckedCity: function delCheckedCity(value) {
      var _this27 = this;
      this.select_code.forEach(function (e, index) {
        if (value === e) {
          _this27.select_code.splice(index, 1);
        }
      });
      this.setWhiteCity();
    },
    addCheckedCity: function addCheckedCity() {
      var _this28 = this;
      if (this.city.length === 0) {
        return false;
      }
      this.city.forEach(function (e) {
        _this28.select_code.push(e[e.length - 1]);
      });
      this.city = [];
      this.setWhiteCity();
    },
    setWhiteCity: function setWhiteCity() {
      var _this29 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var params;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              params = {
                order_id: _this29.ruleType === 'cardType' ? 0 : _this29.order_id,
                rule_id: _this29.ruleType === 'cardType' ? _this29.ruleInfo.id : 0,
                city: _this29.select_code.length ? _this29.select_code.join(',') : [],
                menu_id: _this29.currentRowMenu.id,
                movie_white_list_type: _this29.whiteMovieDialog ? _this29.movie_white_list_type : ''
              };
              if (!(_this29.ruleType == 'order')) {
                _context4.n = 2;
                break;
              }
              _context4.n = 1;
              return _this29.setOrderRuleMenu(false, false);
            case 1:
              if (!_this29.isTempMenu(_this29.currentRowMenu.id) || _this29.ruleInfo.order_id == 0) {
                _this29.getOrderRuleMenu();
              }
            case 2:
              _setWhiteCity(params, _this29.getEntryVal()).then(function (res) {
                var _this29$$refs$onlineO;
                // this.whiteCityDialog = false
                if (_this29.whiteMovieDialog) {
                  //  电影的单独拆除来处理
                  _this29.openWhiteMovieCity();
                } else {
                  _this29.openWhiteCity(1, _this29.whiteCityType);
                }
                (_this29$$refs$onlineO = _this29.$refs.onlineOrderConfig) === null || _this29$$refs$onlineO === void 0 ? void 0 : _this29$$refs$onlineO.loadData();
              });
            case 3:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    searchCinema: function searchCinema() {
      this.getWhiteCinemaData();
      this.getCinemaData();
    },
    // 影院白名单数据
    getWhiteCinemaData: function getWhiteCinemaData() {
      var _this30 = this;
      var params = _objectSpread(_objectSpread(_objectSpread({}, this.searchForm), this.cinemaPage1), {}, {
        status: 1
      });
      params.city_id = this.city_id.length ? this.city_id[this.city_id.length - 1] : '';
      params.order_id = this.ruleType === 'cardType' ? 0 : this.order_id;
      params.rule_id = this.ruleType === 'cardType' ? this.ruleInfo.id : 0;
      getCinemaList(params).then(function (res) {
        _this30.whiteCinemaList = res.data;
        _this30.pages1 = res.pages;
        _this30.whiteCinemaTotal = res.pages.totalCount || 0;
      });
    },
    // 影院数据
    getCinemaData: function getCinemaData(status) {
      var _this31 = this;
      var params = _objectSpread(_objectSpread(_objectSpread({}, this.searchForm), this.cinemaPage2), {}, {
        status: 2
      });
      params.city_id = this.city_id.length ? this.city_id[this.city_id.length - 1] : '';
      params.rule_id = this.ruleType === 'cardType' ? this.ruleInfo.id : 0;
      params.order_id = this.ruleType === 'cardType' ? 0 : this.order_id;
      getCinemaList(params).then(function (res) {
        _this31.cinemaList = res.data;
        _this31.pages2 = res.pages;
      });
    },
    delWhiteCinema: function delWhiteCinema(row) {
      var _this32 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _this32.$confirm("\u662F\u5426\u5C06\u9009\u4E2D\u5F71\u9662\u79FB\u9664\u767D\u540D\u5355\uFF1F", '移除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
                var ids, params;
                return _regenerator().w(function (_context5) {
                  while (1) switch (_context5.n) {
                    case 0:
                      ids = _this32.checkedWhiteCinema.map(function (i) {
                        return i.id;
                      });
                      params = {
                        order_id: _this32.ruleType === 'cardType' ? 0 : _this32.order_id,
                        rule_id: _this32.ruleType === 'cardType' ? _this32.ruleInfo.id : 0,
                        type: 1,
                        cinema_id: ids
                      };
                      if (!(_this32.ruleType == 'order')) {
                        _context5.n = 2;
                        break;
                      }
                      _context5.n = 1;
                      return _this32.setOrderRuleMenu(false, false);
                    case 1:
                      if (!_this32.isTempMenu(_this32.currentRowMenu.id) || _this32.ruleInfo.order_id == 0) {
                        _this32.getOrderRuleMenu();
                      }
                    case 2:
                      delCinema(params).then(function (res) {
                        _this32.searchCinema();
                        _this32.$message.success('移除成功');
                      });
                    case 3:
                      return _context5.a(2);
                  }
                }, _callee5);
              })));
            case 1:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    delAllWhiteCinema: function delAllWhiteCinema() {
      var _this33 = this;
      this.$confirm("\u662F\u5426\u79FB\u9664\u6240\u6709\u767D\u540D\u5355\uFF1F", '移除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var params = {
          order_id: _this33.ruleType === 'cardType' ? 0 : _this33.order_id,
          rule_id: 0,
          type: 2
        };
        delCinema(params).then(function (res) {
          _this33.searchCinema();
        });
      });
    },
    addWhiteCinema: function addWhiteCinema() {
      var _this34 = this;
      this.$confirm("\u662F\u5426\u5C06\u9009\u4E2D\u5F71\u9662\u6DFB\u52A0\u767D\u540D\u5355\uFF1F", '添加', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var ids, params;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              ids = _this34.checkedCinema.map(function (i) {
                return i.id;
              });
              if (!(ids.length == 0)) {
                _context7.n = 1;
                break;
              }
              return _context7.a(2, false);
            case 1:
              params = {
                order_id: _this34.ruleType === 'cardType' ? 0 : _this34.order_id,
                rule_id: _this34.ruleType === 'cardType' ? _this34.ruleInfo.id : 0,
                cinema_id: ids,
                menu_id: _this34.currentRowMenu.id,
                movie_white_list_type: _this34.whiteMovieDialog ? _this34.movie_white_list_type : ''
              };
              if (!(_this34.ruleType == 'order')) {
                _context7.n = 3;
                break;
              }
              _context7.n = 2;
              return _this34.setOrderRuleMenu(false, false);
            case 2:
              if (!_this34.isTempMenu(_this34.currentRowMenu.id) || _this34.ruleInfo.order_id == 0) {
                _this34.getOrderRuleMenu();
              }
            case 3:
              _addWhiteCinema(params).then(function (res) {
                _this34.searchCinema();
                _this34.$message.success('添加成功');
              });
            case 4:
              return _context7.a(2);
          }
        }, _callee7);
      })));
    },
    handleChangeCinema: function handleChangeCinema(val, type) {
      if (type == 1) {
        this.checkedCinema = val;
      } else {
        this.checkedWhiteCinema = val;
      }
    },
    openExportDialog: function openExportDialog() {
      this.uploadFiledDialogShow = true;
      this.dialogFileTitle = '批量更新影院白名单';
      this.demoTitle = '下载模板文件，根据模板中批注填写信息';
      this.upTitle = '上传前请确认信息填写是否正确，文件仅支持xlsx格式，且大小不超过10M';
      this.tipsTitle = '导入不会覆盖历史导入信息，请注意是否需要作废已导入的配送信息';
    },
    // 下载礼包配送模板
    emitDownDemo: function emitDownDemo() {
      ordersTemplateDownload({
        type: 4
      }).then(function (res) {
        if (res.data.file_name) {
          window.open(res.data.file_name);
        }
      });
    },
    // 自定义上传礼包信息
    emitUpload: function emitUpload(file) {
      var _this35 = this;
      var params = new FormData();
      params.append('file', file.file);
      upCinemaFile(params).then(function (res) {
        _this35.$refs.myUploadchild.error_num = res.data.error_num;
        _this35.packageFile = file.file;
        if (res.data.error_num > 0) {
          _this35.$refs.myUploadchild.haveError = true;
          _this35.errorFileUrl = res.data.file_name;
        } else {
          _this35.modal_key = res.data.modal_key;
          _this35.$message.success('上传成功');
          _this35.$refs.myUploadchild.haveError = false;
        }
      }).catch(function () {
        _this35.packageFile = '';
      });
    },
    // 下载错误信息
    emitErrorFile: function emitErrorFile() {
      // window.open(this.errorFileUrl)
      var newTab = window.open('about:blank');
      newTab.location.href = this.errorFileUrl;
    },
    // 保存上传礼包配送信息
    emitSaveFile: function emitSaveFile() {
      var _this36 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var params;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              if (!(_this36.$refs.myUploadchild.error_num > 0)) {
                _context8.n = 1;
                break;
              }
              _this36.$message.error('上传文件错误，请修改错误后在上传提交！');
              return _context8.a(2, false);
            case 1:
              if (!(_this36.packageFile === '')) {
                _context8.n = 2;
                break;
              }
              _this36.$message.error('请选择正确的上传文件！');
              return _context8.a(2, false);
            case 2:
              params = new FormData();
              params.append('order_id', _this36.ruleType === 'cardType' ? 0 : _this36.order_id);
              params.append('rule_id', _this36.ruleType === 'cardType' ? _this36.ruleInfo.id : 0);
              params.append('modal_key', _this36.modal_key);
              if (!(_this36.ruleType == 'order')) {
                _context8.n = 4;
                break;
              }
              _context8.n = 3;
              return _this36.setOrderRuleMenu();
            case 3:
              if (!_this36.isTempMenu(_this36.currentRowMenu.id) || _this36.ruleInfo.order_id == 0) {
                _this36.getOrderRuleMenu();
              }
            case 4:
              confirmUpCinemaFile(params).then(function (res) {
                _this36.$message.success('导入成功');
                _this36.modal_key = false;
                _this36.packagePage = 1;
                _this36.searchCinema(); // 刷新影院列表
                _this36.uploadFiledDialogShow = false;
              });
            case 5:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    },
    delCheckedBox: function delCheckedBox(index) {
      this.checkedSupplier.splice(index, 1);
    },
    openTagDialog: function openTagDialog() {
      var _this37 = this;
      var params = _objectSpread({}, this.searchTags);
      params.ids = this.notTags.map(function (item) {
        return item.id;
      });
      params.bin_id = this.ruleInfo.bin_id;
      getNotTags(params).then(function (res) {
        res.data.forEach(function (e) {
          e.name = e.tag_name;
        });
        _this37.tagList = res.data;
        _this37.pages = res.pages;
        _this37.notTagDialog = true;
      });
    },
    addNotTags: function addNotTags() {
      this.notTags = this.notTags.concat(this.tempTags);
      this.notTagDialog = false;
    },
    delNotTag: function delNotTag(index) {
      this.notTags.splice(index, 1);
    },
    // 设置利润率
    openDiscountDialog: function openDiscountDialog(row) {
      if (this.batchIds.length) {
        this.$message.warning('批量修改订单暂不支持此操作');
        return false;
      }
      this.currentRowMenu = row;
      this.discountTabsVal = 'cake_store';
      this.showDiscountTabs = row.is_support == 1 ? true : false;
      this.commonDiscount = this.menusInfo.cake_store_discount;
      this.discountDialog = true;
    },
    handleClickDisCountTab: function handleClickDisCountTab() {
      this.commonDiscount = this.discountTabsVal == 'cake_store' ? this.menusInfo.cake_store_discount : this.menusInfo.cake_store_zyd_discount;
    },
    // 蛋糕黑名单
    openCakeDialog: function openCakeDialog(category_id, row) {
      if (this.batchIds.length) {
        this.$message.warning('批量修改订单暂不支持此操作');
        return false;
      }
      this.currentRowMenu = row;
      this.category_id = category_id;
      this.dialogType = 3;
      this.checkedCakes = [];
      this.cakeList = [];
      this.searchBrand.brand_name = '';
      if (this.ruleType === 'cardType') {
        this.getCommonCakeHomeBrands();
      } else {
        this.getCakeList();
      }
      this.cakeDialog = true;
    },
    // 管理中心获取蛋糕到家数据
    getCommonCakeHomeBrands: function getCommonCakeHomeBrands() {
      var _this38 = this;
      _getCommonCakeHomeBrands(_objectSpread(_objectSpread({}, this.searchBrand), {}, {
        rule_id: this.ruleInfo.id,
        category_id: this.category_id
      })).then(function (res) {
        _this38.cakeList = res.data.list;
        _this38.checkedCakes = res.data.brands;
        _this38.pages = res.pages;
      });
    },
    // 蛋糕到店与自由兑黑名单
    openCommonMenuDialog: function openCommonMenuDialog(row, type) {
      if (this.batchIds.length) {
        this.$message.warning('批量修改订单暂不支持此操作');
        return false;
      }
      this.currentRowMenu = row;
      this.cakeStoreType = type;
      this.dialogType = {
        cake_store: 2,
        cake: 3,
        online_order: 4,
        movie: 6,
        lvmama: 7
      }[row.type];
      if (['cake', 'movie', 'online_order'].includes(row.type)) {
        this.whiteCityType = row.type;
        this.getCheckedCityList(); // 获取城市白/黑名单数量，传固定cake类型
      }
      row.type === 'movie' && this.getWhiteCinemaData();
      // this.checkedCakes = []
      // this.cakeList = []
      // this.searchBrand.brand_name = ''
      // this.getCakeList()
      // this.cakeDialog = true
      // 用新的
      this.cakeStoreDrawer = true;
    },
    changeType: function changeType(val) {
      // 2 蛋糕到点黑名单 1 自由兑黑名单
      this.dialogType = val == 'cake_store' ? 2 : 1;
    },
    getCakeList: function getCakeList() {
      var _this39 = this;
      // 蛋糕到家
      if (this.dialogType === 3) {
        getCakeHomeBrands(_objectSpread(_objectSpread({}, this.searchBrand), {}, {
          order_id: this.order_id,
          category_id: this.category_id
        })).then(function (res) {
          _this39.cakeList = res.data.list;
          // 未保存的蛋糕到家品牌黑名单搜索时不在重置临时添加的已选品牌
          if (!_this39.checkedCakes.length) {
            _this39.checkedCakes = res.data.brands;
          }
          _this39.pages = res.pages;
        });
        return false;
      }
    },
    // 批量添加蛋糕
    batchAddCake: function batchAddCake() {
      this.checkedCakes = this.checkedCakes.concat(this.tempCakes);
      this.tempCakes = [];
      this.$refs.multipleTable.clearSelection();
    },
    // 清空已选品牌
    clearChecked: function clearChecked() {
      this.checkedCakes = [];
      this.checkedOnlineOrder = [];
      this.checkedMovieZydList = [];
    },
    // 禁用selection
    selectable: function selectable(row, index) {
      var _this40 = this;
      var indexs = [];
      this.checkedCakes.forEach(function (e) {
        var condition = _this40.dialogType === 3 ? e.id === row.id : e.brand_id === row.brand_id;
        if (condition) {
          indexs.push(index);
        }
      });
      if (indexs.indexOf(index) === -1) {
        return true;
      }
    },
    // 禁用selection
    onlineOrderSelectable: function onlineOrderSelectable(row, index) {
      var indexs = [];
      this.checkedOnlineOrder.forEach(function (e) {
        var condition = e.brand_id === row.brand_id;
        if (condition) {
          indexs.push(index);
        }
      });
      if (indexs.indexOf(index) === -1) {
        return true;
      }
    },
    delCheckedCake: function delCheckedCake(index, type) {
      if (type == 'cake') {
        this.checkedCakes.splice(index, 1);
      } else if (type == 'onlineOrder') {
        this.checkedOnlineOrder.splice(index, 1);
      }
    },
    setBlackCake: function setBlackCake() {
      var _arguments = arguments,
        _this41 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var props, ids, _props$selectIds, selectIds, _props$blackSelectZyd, blackSelectZyd, _props$params, params, _props$showMsg, showMsg, cb, result, allFalse;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              props = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {};
              // this.dialogType === 3 为蛋糕到家 其他为自由兑1 及到店2
              // return false
              ids = [];
              if (_this41.dialogType === 3) {
                ids = _this41.checkedCakes.map(function (e) {
                  return e.id;
                });
              } else if (_this41.dialogType == 2) {
                ids = _this41.checkedCakes.map(function (e) {
                  return e.brand_id;
                });
              }
              _props$selectIds = props.selectIds, selectIds = _props$selectIds === void 0 ? [] : _props$selectIds, _props$blackSelectZyd = props.blackSelectZyd, blackSelectZyd = _props$blackSelectZyd === void 0 ? [] : _props$blackSelectZyd, _props$params = props.params, params = _props$params === void 0 ? {} : _props$params, _props$showMsg = props.showMsg, showMsg = _props$showMsg === void 0 ? true : _props$showMsg, cb = props.cb;
              if (selectIds.length) {
                // 子组件中传来的ids数据
                ids = selectIds;
              }
              ids = ids.length ? ids : '';
              if (_this41.dialogType == 1) {
                // // 这个是勾选了子级的处理
                result = blackSelectZyd.flatMap(function (item) {
                  return item.city.flatMap(function (subArray) {
                    var all_city = subArray.map(function (i) {
                      return i.code;
                    }); // 自由兑取消全量替换数据形式，因历史数据问题，后端要求设为可用的数据 需将所有城市code传过去
                    return subArray.filter(function (obj) {
                      return obj.selected;
                    }) // 只保留 selected === true
                    .reduce(function (acc, _ref3) {
                      var zyd_id = _ref3.zyd_id,
                        code = _ref3.code;
                      // 按 zyd_id 分组
                      var exist = acc.find(function (v) {
                        return v.top === zyd_id;
                      });
                      exist ? exist.sub.push(code) : acc.push({
                        top: zyd_id,
                        sub: [code],
                        all_city: all_city
                      });
                      return acc;
                    }, []);
                  });
                }); // 这个是只勾选了父级没有勾选子级 传zyd_id的
                allFalse = blackSelectZyd.forEach(function (item) {
                  // 处理只勾选了父级 并且是组合的
                  if (item.is_group == 1) {
                    // 如果是组合的 并且没有子级勾选需要把所有的子级传过去
                    if (item.city.every(function (subArray) {
                      return subArray.every(function (obj) {
                        return obj.selected == false;
                      });
                    })) {
                      // result.push({ top: item.zyd_id })
                      var newArr = item.city.flatMap(function (group) {
                        return group.map(function (items) {
                          return {
                            top: items.zyd_id,
                            sub: items.code
                          };
                        });
                      });
                      result.push.apply(result, _toConsumableArray(newArr));
                    }
                  } else {
                    if (item.city.every(function (subArray) {
                      return subArray.every(function (obj) {
                        return obj.selected == false;
                      });
                    })) {
                      result.push({
                        top: item.zyd_id
                      });
                    }
                  }
                });
              }
              if (!(_this41.dialogType === 1)) {
                _context9.n = 5;
                break;
              }
              if (!(_this41.ruleType === 'cardType')) {
                _context9.n = 1;
                break;
              }
              setCommonBlackCake(_objectSpread({
                rule_id: _this41.ruleInfo.id,
                zyd_not_info: result.length ? result : '',
                zyd_brands: ids,
                menu_id: _this41.currentRowMenu.id
              }, params)).then(function (res) {
                _this41.cakeDialog = false;
                typeof cb === 'function' && cb();
              });
              _context9.n = 4;
              break;
            case 1:
              if (!(_this41.ruleType == 'order')) {
                _context9.n = 3;
                break;
              }
              _context9.n = 2;
              return _this41.setOrderRuleMenu(false, showMsg);
            case 2:
              if (!_this41.isTempMenu(_this41.currentRowMenu.id) || _this41.ruleInfo.order_id == 0) {
                _this41.getOrderRuleMenu();
              }
            case 3:
              _setBlackCake(_objectSpread({
                order_id: _this41.order_id,
                zyd_brands: ids,
                zyd_not_info: result.length ? result : '',
                menu_id: _this41.currentRowMenu.id
              }, params)).then(function (res) {
                _this41.cakeDialog = false;
                typeof cb === 'function' && cb();
              });
            case 4:
              _context9.n = 13;
              break;
            case 5:
              if (!(_this41.dialogType === 2)) {
                _context9.n = 10;
                break;
              }
              if (!(_this41.ruleType === 'cardType')) {
                _context9.n = 6;
                break;
              }
              setCommonBlackCake(_objectSpread({
                rule_id: _this41.ruleInfo.id,
                cake_store_not_brands: ids,
                menu_id: _this41.currentRowMenu.id
              }, params)).then(function (res) {
                _this41.cakeDialog = false;
                typeof cb === 'function' && cb();
              });
              _context9.n = 9;
              break;
            case 6:
              if (!(_this41.ruleType == 'order')) {
                _context9.n = 8;
                break;
              }
              _context9.n = 7;
              return _this41.setOrderRuleMenu(false, showMsg);
            case 7:
              if (!_this41.isTempMenu(_this41.currentRowMenu.id) || _this41.ruleInfo.order_id == 0) {
                _this41.getOrderRuleMenu();
              }
            case 8:
              _setBlackCake(_objectSpread({
                order_id: _this41.order_id,
                cake_store_not_brands: ids,
                menu_id: _this41.currentRowMenu.id
              }, params)).then(function (res) {
                _this41.cakeDialog = false;
                typeof cb === 'function' && cb();
              });
            case 9:
              _context9.n = 13;
              break;
            case 10:
              if (!(_this41.ruleType == 'order')) {
                _context9.n = 12;
                break;
              }
              _context9.n = 11;
              return _this41.setOrderRuleMenu(false, showMsg);
            case 11:
              if (!_this41.isTempMenu(_this41.currentRowMenu.id) || _this41.ruleInfo.order_id == 0) {
                _this41.getOrderRuleMenu();
              }
            case 12:
              if (_this41.ruleType === 'cardType') {
                setCommonCakeHomeBrands({
                  rule_id: _this41.ruleInfo.id,
                  cake_home_not_brands: ids,
                  menu_id: _this41.currentRowMenu.id
                }).then(function (res) {
                  _this41.cakeDialog = false;
                  typeof cb === 'function' && cb();
                });
              } else {
                setCakeHomeBrands({
                  order_id: _this41.order_id,
                  cake_home_not_brands: ids,
                  menu_id: _this41.currentRowMenu.id
                }).then(function (res) {
                  _this41.cakeDialog = false;
                  typeof cb === 'function' && cb();
                });
              }
            case 13:
              return _context9.a(2);
          }
        }, _callee9);
      }))();
    },
    // 设置蛋糕到店利润率
    setDiscount: function setDiscount() {
      var _arguments2 = arguments,
        _this42 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var props, ratio, activeTab, cb, reg, params;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              props = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : {};
              ratio = props.ratio, activeTab = props.activeTab, cb = props.cb;
              _this42.commonDiscount = ratio || _this42.commonDiscount;
              _this42.discountTabsVal = activeTab || _this42.discountTabsVal;
              reg = /^((-|\+)?\d+)\.?(\d{0,2})$/;
              if (reg.test(_this42.commonDiscount)) {
                _context0.n = 1;
                break;
              }
              _this42.$message.warning('请输入数字格式,最多支持两位小数');
              return _context0.a(2, false);
            case 1:
              params = {
                order_id: _this42.ruleType === 'cardType' ? 0 : _this42.order_id,
                rule_id: _this42.ruleType === 'cardType' ? _this42.ruleInfo.id : 0,
                cake_store_discount: _this42.commonDiscount,
                menu_id: _this42.currentRowMenu.id
              };
              if (!(_this42.ruleType == 'order')) {
                _context0.n = 3;
                break;
              }
              _context0.n = 2;
              return _this42.setOrderRuleMenu();
            case 2:
              if (!_this42.isTempMenu(_this42.currentRowMenu.id) || _this42.ruleInfo.order_id == 0) {
                _this42.getOrderRuleMenu();
              }
            case 3:
              if (_this42.discountTabsVal == 'cake_store') {
                params.cake_store_discount = _this42.commonDiscount;
                _this42.setCakeStoreDiscount(params).then(function () {
                  typeof cb === 'function' && cb();
                });
              } else {
                params.cake_store_zyd_discount = _this42.commonDiscount;
                _this42.setCakeStoreZydDiscount(params).then(function () {
                  typeof cb === 'function' && cb();
                });
              }
            case 4:
              return _context0.a(2);
          }
        }, _callee0);
      }))();
    },
    // 自由兑利润率
    setCakeStoreZydDiscount: function setCakeStoreZydDiscount(params) {
      var _this43 = this;
      return _setCakeStoreZydDiscount(params).then(function (res) {
        _this43.discountDialog = false;
        // 非组合临时设置利润率
        if (_this43.discountTabsVal == 'cake_store') {
          _this43.menusInfo.cake_store_discount = _this43.commonDiscount;
        } else {
          _this43.menusInfo.cake_store_zyd_discount = _this43.commonDiscount;
        }
      });
    },
    // 设置蛋糕到店利润率
    setCakeStoreDiscount: function setCakeStoreDiscount(params) {
      var _this44 = this;
      return _setCakeStoreDiscount(params).then(function (res) {
        _this44.discountDialog = false;
        // 非组合临时设置利润率
        if (_this44.discountTabsVal == 'cake_store') {
          _this44.menusInfo.cake_store_discount = _this44.commonDiscount;
        } else {
          _this44.menusInfo.cake_store_zyd_discount = _this44.commonDiscount;
        }
      });
    },
    cancelDiscountDialog: function cancelDiscountDialog() {
      this.discountDialog = false;
    },
    // 搜索品牌
    handleSearchTag: function handleSearchTag() {
      this.searchTags.page = 1;
      this.searchTags.pagesize = 20;
      this.openTagDialog();
    },
    // 分页操作
    onChange: function onChange(val, flag) {
      if (flag === 1) {
        this.searchBrand.page = val;
        this.getNotBrand();
      } else if (flag === 2) {
        this.cinemaPage2.page = val;
        this.getCinemaData();
      } else if (flag === 3) {
        this.searchTags.page = val;
        this.openTagDialog();
      } else if (flag === 4) {
        this.searchBrand.page = val;
        this.getCakeList();
      } else if (flag === 5) {
        this.searchCity.page = val;
        this.getCheckedCityList();
      } else if (flag === 6) {
        this.cinemaPage1.page = val;
        this.getWhiteCinemaData();
      } else if (flag === 7) {
        this.searchBrand.page = val;
        this.getOnlineOrderList();
      }
    },
    sizeChange: function sizeChange(val, status) {
      if (status === 1) {
        this.cinemaPage1.pagesize = val;
        this.getWhiteCinemaData();
      } else if (status == 4) {
        this.searchBrand.pagesize = val;
        this.getCakeList();
      } else {
        this.cinemaPage2.pagesize = val;
        this.getCinemaData();
      }
    },
    // 切换菜单积分价值
    menuChangeIntegral: function menuChangeIntegral(row, flag, index) {
      this.integralType = flag;
      if (this.$hasBtnRoles('/orders/new-card-rule/set-config')) {
        this.menuItem = row;
        console.log(row, 123);
        this.menu_integral_value = Number(row.is_integral_value);
        this.integralMenuDialog = true;
        this.integralIndex = index;
      }
    },
    // 功能菜单设置积分价值
    setIntegralMenu: function setIntegralMenu() {
      var _this45 = this;
      var parentIndex = this.menuList.findIndex(function (item) {
        return item.id == _this45.menuItem.parentId;
      });
      if (this.menuItem.parentId) {
        var childIndex = this.menuList[parentIndex].sub_categorys.findIndex(function (item) {
          return item.id == _this45.menuItem.id;
        });
        if (this.integralType == 'common') {
          this.menuList[parentIndex].sub_categorys[childIndex].is_integral_value = this.menu_integral_value;
        } else {
          this.menuList[parentIndex].sub_categorys[childIndex].is_integral_value = this.menu_integral_value;
        }
      } else {
        if (this.integralType == 'common') {
          this.menuList[this.integralIndex].is_integral_value = this.menu_integral_value;
        } else {
          this.gift_menus[this.integralIndex].is_integral_value = this.menu_integral_value;
        }
      }
      this.integralMenuDialog = false;
    },
    // 打开配置积分价值弹框
    openIntegralDialog: function openIntegralDialog() {
      this.integralDialog = true;
    },
    // 保存积分价值
    setIntegral: function setIntegral() {
      var _this46 = this;
      this.$refs['integralForm'].validate(function (valid) {
        if (valid) {
          _this46.form.is_open_integral_value = _this46.integralForm.is_open_integral_value;
          _this46.form.integral_value_unit = _this46.integralForm.integral_value_unit;
          _this46.form.integral_value_rate = _this46.integralForm.integral_value_rate;
          _this46.isShowIntegral = _this46.integralForm.is_open_integral_value;
          _this46.integralDialog = false;
        }
      });
    },
    // 打开关键词弹框
    openKeywordBlackDialog: function openKeywordBlackDialog(row) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (this.batchIds.length) {
        this.$message.warning('批量修改订单暂不支持此操作');
        return false;
      }
      var _props$openType2 = props.openType,
        openType = _props$openType2 === void 0 ? '' : _props$openType2;
      this.childMenuType = openType;
      this.currentRowMenu = row;
      this.keywordBlackDialog = true;
      var params = {
        order_id: this.ruleType === 'cardType' ? 0 : this.order_id,
        rule_id: this.ruleType === 'cardType' ? this.ruleInfo.id : 0
      };
      if (row.type == 'lvmama') {
        this.getLvmamaKeyword(params);
      } else {
        this.getMovieKeyword(params);
      }
    },
    // 驴妈妈关键字黑名单
    getLvmamaKeyword: function getLvmamaKeyword(params) {
      var _this47 = this;
      _getLvmamaKeyword(params).then(function (res) {
        _this47.keywordArr = res.data;
      });
    },
    // 电影关键字黑名单
    getMovieKeyword: function getMovieKeyword(params) {
      var _this48 = this;
      _getMovieKeyword(params).then(function (res) {
        _this48.keywordArr = res.data;
      });
    },
    // 删除关键词
    delBlackKeyword: function delBlackKeyword(index) {
      this.keywordArr.splice(index, 1);
    },
    // 添加关键词
    addBlackKeyword: function addBlackKeyword() {
      if (this.keyword == '') {
        this.$message.warning('请输入要添加的关键字');
        return false;
      }
      if (this.keywordArr.indexOf(this.keyword) != -1) {
        this.$message.warning('关键字不能重复添加');
        this.keyword = '';
        return false;
      }
      this.keywordArr.push(this.keyword);
      this.keyword = '';
    },
    // 设置关键词
    setBlackKeyword: function setBlackKeyword() {
      var _this49 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var params;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              if (!(_this49.ruleType == 'order')) {
                _context1.n = 2;
                break;
              }
              _context1.n = 1;
              return _this49.setOrderRuleMenu();
            case 1:
              if (!_this49.isTempMenu(_this49.currentRowMenu.id) || _this49.ruleInfo.order_id == 0) {
                _this49.getOrderRuleMenu();
              }
            case 2:
              params = {
                order_id: _this49.ruleType === 'cardType' ? 0 : _this49.order_id,
                rule_id: _this49.ruleType === 'cardType' ? _this49.ruleInfo.id : 0,
                keyword: _this49.keywordArr,
                menu_id: _this49.currentRowMenu.id
              };
              if (_this49.currentRowMenu.type == 'lvmama') {
                setLvmamaKeyword(params).then(function (res) {
                  var _this49$$refs$lvmamaC;
                  _this49.keywordBlackDialog = false;
                  (_this49$$refs$lvmamaC = _this49.$refs.lvmamaConfig) === null || _this49$$refs$lvmamaC === void 0 ? void 0 : _this49$$refs$lvmamaC.loadData();
                });
              } else {
                params.movie_black_keyword = _this49.keywordArr;
                setMovieKeyword(params).then(function (res) {
                  var _this49$$refs$movieCo;
                  _this49.keywordBlackDialog = false;
                  (_this49$$refs$movieCo = _this49.$refs.movieConfig) === null || _this49$$refs$movieCo === void 0 ? void 0 : _this49$$refs$movieCo.loadData();
                });
              }
            case 3:
              return _context1.a(2);
          }
        }, _callee1);
      }))();
    },
    // 关闭电影影院白名单弹框
    closeCinemaDialog: function closeCinemaDialog() {
      this.city_id = [];
      // this.searchForm.cinema_id = ''
      this.searchForm.cinema_name = '';
      this.searchForm.start_discount = '';
      this.searchForm.end_discount = '';
    },
    // 打开线下点单弹框
    openOnlineOrderDialog: function openOnlineOrderDialog(row) {
      if (this.batchIds.length) {
        this.$message.warning('批量修改订单暂不支持此操作');
        return false;
      }
      this.onlineOrderDialog = true;
      this.searchBrand.brand_name = '';
      this.dialogType = 4;
      this.currentRowMenu = row;
      this.getOnlineOrderList();
    },
    // 获取在线点单弹框数据
    getOnlineOrderList: function getOnlineOrderList(val) {
      var _this50 = this;
      if (val == 1) {
        this.searchBrand.page = val;
      }
      // 在线点单数据
      onlineOrderBrandList(_objectSpread(_objectSpread({}, this.searchBrand), {}, {
        order_id: this.ruleType === 'cardType' ? 0 : this.order_id,
        rule_id: this.ruleType === 'cardType' ? this.ruleInfo.id : 0,
        menu_id: this.currentRowMenu.id
      }), this.entryType).then(function (res) {
        _this50.onlineOrderList = res.data.list;
        _this50.checkedOnlineOrder = res.data.brands;
        _this50.pages = res.pages;
      });
    },
    // 批量添加蛋糕
    batchAddOnlineOrder: function batchAddOnlineOrder() {
      this.checkedOnlineOrder = this.checkedOnlineOrder.concat(this.tempOnlineOrder);
      this.tempOnlineOrder = [];
      this.$refs.multipleOnlineOrder.clearSelection();
    },
    // 在线点单table 多选框  change事件
    handleSelectOnlineorder: function handleSelectOnlineorder(val) {
      this.tempOnlineOrder = val;
    },
    openMovieZydDialog: function openMovieZydDialog(row) {
      if (this.batchIds.length) {
        this.$message.warning('批量修改订单暂不支持此操作');
        return false;
      }
      this.movieZydDialog = true;
      this.getMovieZydBrands();
    },
    // 获取电影自由兑弹框数据
    getMovieZydBrands: function getMovieZydBrands() {
      var _this51 = this;
      this.movieZydList = [];
      this.checkedMovieZydList = [];
      _getMovieZydBrands(_objectSpread(_objectSpread({}, this.searchBrand), {}, {
        order_id: this.ruleType === 'cardType' ? 0 : this.order_id,
        rule_id: this.ruleType === 'cardType' ? this.ruleInfo.id : 0
      })).then(function (res) {
        res.data.forEach(function (e) {
          if (e.checked == 1) {
            _this51.checkedMovieZydList.push(e);
          }
        });
        _this51.movieZydList = res.data;
      });
    },
    // 电影自由兑table 多选框  change事件
    handleSelectMovieZyd: function handleSelectMovieZyd(val) {
      this.tempMovieZyd = val;
    },
    batchAddMovieZyd: function batchAddMovieZyd() {
      this.checkedMovieZydList = this.checkedMovieZydList.concat(this.tempMovieZyd);
      this.tempMovieZyd = [];
      this.$refs.movieZydTable.clearSelection();
    },
    delCheckedMovieZyd: function delCheckedMovieZyd(index) {
      this.checkedMovieZydList.splice(index, 1);
    },
    // 禁用selection
    onlineMovieZydSelectTable: function onlineMovieZydSelectTable(row, index) {
      var indexs = [];
      this.checkedMovieZydList.forEach(function (e) {
        var condition = e.name === row.name;
        if (condition) {
          indexs.push(index);
        }
      });
      if (indexs.indexOf(index) === -1) {
        return true;
      }
    },
    // 设置在线点单
    setMovieZydBrands: function setMovieZydBrands() {
      var _this52 = this;
      _setMovieZydBrands({
        order_id: this.ruleType === 'cardType' ? 0 : this.order_id,
        rule_id: this.ruleType === 'cardType' ? this.ruleInfo.id : 0,
        online_zy_not_brands: this.checkedMovieZydList.map(function (item) {
          return item.name;
        })
      }, this.ruleType === 'cardType' ? 'cardType' : 'order').then(function (res) {
        _this52.movieZydDialog = false;
      });
    },
    // 设置在线点单
    setBlackOnlineOrder: function setBlackOnlineOrder() {
      var _arguments3 = arguments,
        _this53 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var props, _props$selectIds2, selectIds, showMsg, cb;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              props = _arguments3.length > 0 && _arguments3[0] !== undefined ? _arguments3[0] : {};
              _props$selectIds2 = props.selectIds, selectIds = _props$selectIds2 === void 0 ? [] : _props$selectIds2, showMsg = props.showMsg, cb = props.cb;
              if (!(_this53.ruleType == 'order')) {
                _context10.n = 2;
                break;
              }
              _context10.n = 1;
              return _this53.setOrderRuleMenu(false, showMsg);
            case 1:
              if (!_this53.isTempMenu(_this53.currentRowMenu.id) || _this53.ruleInfo.order_id == 0) {
                _this53.getOrderRuleMenu();
              }
            case 2:
              _setBlackOnlineOrder({
                order_id: _this53.ruleType === 'cardType' ? 0 : _this53.order_id,
                rule_id: _this53.ruleType === 'cardType' ? _this53.ruleInfo.id : 0,
                online_order_not_brands: selectIds.length ? selectIds : '',
                menu_id: _this53.currentRowMenu.id
              }, _this53.entryType).then(function (res) {
                _this53.onlineOrderDialog = false;
                typeof cb === 'function' && cb();
              });
            case 3:
              return _context10.a(2);
          }
        }, _callee10);
      }))();
    },
    isSavePageConfig: function isSavePageConfig() {
      var _this54 = this;
      return new Promise(function (resolve, reject) {
        if (_this54.ruleInfo.order_id == 0 || !_this54.isTempMenu(_this54.currentRowMenu.id)) {
          var menus = [];
          var checkedSupplier = [];
          var checkedNotBrands = [];
          var custom_cat = [];
          var rule_menu = [];
          _this54.gift_menus.forEach(function (el) {
            rule_menu.push({
              id: el.id,
              is_integral_value: el.is_integral_value
            });
          });
          _this54.menuList.forEach(function (el) {
            rule_menu.push({
              id: el.id,
              is_integral_value: el.is_integral_value
            });
            menus.push(el.id);
            el.childrens.forEach(function (e) {
              if (e.selected) {
                custom_cat.push(e.id);
              }
            });
          });
          _this54.checkedSupplier.forEach(function (el) {
            checkedSupplier.push(el.id);
          });
          _this54.checkedNotBrands.forEach(function (el) {
            checkedNotBrands.push(el.id);
          });
          var params = _objectSpread(_objectSpread({}, _this54.form), {}, {
            special_menus: [],
            menus: menus.length ? menus : null,
            rule_menu: rule_menu.length ? rule_menu : null,
            not_suppliers: checkedSupplier.length ? checkedSupplier : null,
            not_brands: checkedNotBrands.length ? checkedNotBrands : null,
            custom_cat: custom_cat,
            not_tags: _this54.notTags.length ? _this54.notTags.map(function (item) {
              return item.id;
            }) : null
          });
          if (_this54.cardBinGroupId != 3) {
            params.package_view_type = '';
          }
          if (params.background_image.indexOf(_this54.$ossurl) === 0) {
            params.background_image = params.background_image.replace(_this54.$ossurl, '');
          }
          var special_brands = [];
          _this54.checkedSpecialBrands.forEach(function (el) {
            special_brands.push(el.id);
          });
          params.special_brands = special_brands.length ? special_brands : null;
          params.order_id = _this54.batchIds.length ? _this54.batchIds : _this54.order_id;
          var alias = _this54.menuList.map(function (e) {
            return {
              id: e.id,
              name: e.alias_name
            };
          });
          params.menus_alias = alias;
          _this54.loading = true;
          setOrderRule(params).then(function () {
            _this54.loading = false;
            resolve();
          }).catch(function () {
            _this54.loading = false;
            reject('err');
          });
        } else {
          // 无需处理
          resolve();
        }
      });
    },
    // 判断是否为临时加入的(未保存)菜单
    isTempMenu: function isTempMenu(id) {
      return this.copyMenuList.some(function (item) {
        return item.id == id;
      });
    },
    openMenuSwitchDialog: function openMenuSwitchDialog(row, index) {
      this.is_show = row.is_show;
      this.isShowIndex = this.menuList.findIndex(function (item) {
        return item.id == row.id;
      });
      this.menuSwitchDialog = true;
    },
    setMenuSwitch: function setMenuSwitch() {
      this.menuList[this.isShowIndex].is_show = this.is_show;
      this.menuSwitchDialog = false;
    },
    // 切换电影白名单类型
    movieTypeChange: function movieTypeChange(val) {
      if (this.whiteCinemaList.length || this.checkedCityList.length) {
        if (val == 1) {
          this.movie_white_list_type = 2;
        }
        if (val == 2) {
          this.movie_white_list_type = 1;
        }
        var tips = val == 1 ? '已存在城市白名单，无法设置影院白名单！请清除城市白名单后，才可设置！' : '已存在影院白名单，无法设置城市白名单！请清除影院白名单后，才可设置！';
        this.$confirm(tips, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {});
        return false;
      }
      this.openWhiteMovieCity();
    },
    // 打开电影白名单
    openWhiteMovieCity: function openWhiteMovieCity(row) {
      var _this55 = this;
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (this.batchIds.length) {
        this.$message.warning('批量修改订单暂不支持此操作');
        return false;
      }
      var _props$openType3 = props.openType,
        openType = _props$openType3 === void 0 ? '' : _props$openType3;
      if (openType) {
        this.childMenuType = openType;
      }
      if (row) {
        this.currentRowMenu = row;
      }
      if (!this.movie_white_list_type) {
        this.whiteMovieDialog = true;
        return false;
      }
      // 1 等于影院白名单
      if (this.movie_white_list_type == 2) {
        // 蛋糕 & 电影 支持配置城市白名单
        this.whiteCityType = 'movie';
        this.city = [];
        var params = {
          order_id: this.ruleType === 'cardType' ? 0 : this.order_id,
          rule_id: this.ruleType === 'cardType' ? this.ruleInfo.id : 0,
          menu_id: this.currentRowMenu.id
        };
        getCityTree(params, this.getEntryVal()).then(function (res) {
          _this55.cityTree = JSON.parse(JSON.stringify(res.data.tree));
          _this55.select_code = res.data.select_code;
          _this55.delDisabledCity(res.data.tree);
          _this55.tempCity = res.data.tree;
        });
        this.whiteMovieDialog = true;
        this.getCheckedCityList();
      } else {
        if (this.cityTree.length === 0) {
          this.openWhiteCity();
        }
        this.whiteMovieDialog = true;
        this.getWhiteCinemaData();
        this.getCinemaData();
      }
    },
    // 取消设置白名单
    cancelWhiteMovie: function cancelWhiteMovie() {
      var _this56 = this;
      this.$confirm("\u60A8\u786E\u5B9A\u6E05\u9664".concat(this.movie_white_list_type == 1 ? '影院白名单' : '城市白名单', "\u5417\uFF1F\u70B9\u51FB\u786E\u8BA4\u6309\u94AE\uFF0C\u6E05\u9664\u89C4\u5219\u4FE1\u606F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var params = {
          order_id: _this56.ruleType === 'cardType' ? 0 : _this56.order_id,
          rule_id: _this56.ruleType === 'cardType' ? _this56.ruleInfo.id : 0
        };
        delWhiteMovieList(params).then(function () {
          _this56.movie_white_list_type = 0;
          _this56.whiteCinemaList = [];
          _this56.checkedCityList = [];
          _this56.$message.success('操作成功');
        });
      });
    },
    handleBeforeClose: function handleBeforeClose() {
      this.whiteMovieDialog = false;
      if (this.whiteCinemaList.length) {
        this.movie_white_list_type = 1;
      }
      if (this.checkedCityList.length) {
        this.movie_white_list_type = 2;
      }
      if (!this.checkedCityList.length && !this.whiteCinemaList.length) {
        this.movie_white_list_type = 0;
      }
      if (this.childMenuType === 'setWhiteMovie') {
        var _this$$refs$movieConf;
        (_this$$refs$movieConf = this.$refs.movieConfig) === null || _this$$refs$movieConf === void 0 ? void 0 : _this$$refs$movieConf.getList();
      }
    },
    // 获取组合子菜单
    openGroupMenusDialog: function openGroupMenusDialog(rows) {
      var _this57 = this;
      this.currentRowMenu = rows;
      var ids = rows.sub_categorys.map(function (i) {
        return i.id;
      });
      getChildFunctionMenu({
        category_id: rows.id,
        ids: ids,
        bin_id: this.bin_id,
        order_id: this.ruleType == 'order' ? this.order_id : 0
      }).then(function (res) {
        _this57.checkedGroupChildIds = [];
        res.data.forEach(function (e) {
          e.is_integral_value = '0';
          e.parentId = rows.id;
          if (e.selected == 1) {
            // 已选中的组合子菜单
            _this57.checkedGroupChildIds.push(e.id);
          }
        });
        _this57.groupChildMenus = res.data;
        _this57.groupMenusDialog = true;
      });
    },
    setCheckedGropChildMenu: function setCheckedGropChildMenu() {
      var _this58 = this;
      // 所有选中的子菜单数据
      var parentIndex = this.menuList.findIndex(function (item) {
        return item.id == _this58.currentRowMenu.id;
      });
      // 已选的数据菜单
      var tempChildMenus = [];
      this.checkedGroupChildIds.forEach(function (e) {
        _this58.groupChildMenus.forEach(function (el) {
          if (e == el.id) {
            tempChildMenus.push(el);
          }
        });
      });
      var idsInArray2 = new Set(this.checkedGroupChildIds.map(function (item) {
        return item;
      }));
      for (var i = this.menuList[parentIndex].sub_categorys.length - 1; i >= 0; i--) {
        if (!idsInArray2.has(this.menuList[parentIndex].sub_categorys[i].id)) {
          // 列表里的菜单 不在已选菜单删除
          this.menuList[parentIndex].sub_categorys.splice(i, 1);
        }
      }
      tempChildMenus.forEach(function (item1) {
        // 如果菜单里没有就推进去 已经有的不处理
        if (!_this58.menuList[parentIndex].sub_categorys.some(function (item2) {
          return item2.id == item1.id;
        })) {
          _this58.menuList[parentIndex].sub_categorys.push(item1);
        }
      });
      this.groupMenusDialog = false;
    },
    changeGroupChildMenu: function changeGroupChildMenu(val) {
      var _this59 = this;
      var parentIndex = this.menuList.findIndex(function (item) {
        return item.id == _this59.currentRowMenu.id;
      });
      var allMenus = [];
      this.menuList.forEach(function (e) {
        if (e.id != _this59.menuList[parentIndex].id) {
          if (e.group_type) {
            allMenus.push(e);
          } else {
            allMenus = allMenus.concat(e.sub_categorys);
          }
        }
      });
      var sameItem = {
        id: '',
        flag: false,
        category_name: ''
      };
      allMenus.forEach(function (e) {
        if (e.id == val.id) {
          sameItem.flag = true;
          sameItem.id = e.id;
          sameItem.category_name = e.category_name;
        }
      });
      if (sameItem.flag) {
        this.$message({
          message: "(".concat(sameItem.id, ")") + sameItem.category_name + ' 的单一类型已存在，无法添加',
          type: 'warning',
          duration: 5000
        });
        var index = this.checkedGroupChildIds.findIndex(function (item) {
          return item == val.id;
        });
        if (index != -1) {
          this.checkedGroupChildIds.splice(index, 1);
        }
        sameItem.flag = false;
        sameItem.category_name = '';
      }
    },
    copyOrderRule: function copyOrderRule() {
      var event = this.$refs.copyOrderRule;
      event.copyOrderRuleDialog = true;
      event.order_id = this.orderInfo.order_id;
    },
    setIntegralValue: function setIntegralValue(type) {
      var _this60 = this;
      this.$confirm("\u662F\u5426\u5C06\u6240\u6709\u83DC\u5355\u79EF\u5206\u4EF7\u503C\u8BBE\u7F6E\u4E3A".concat(type == 1 ? '是' : '否', "\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this60.menuList.forEach(function (e) {
          var _e$sub_categorys, _e$sub_categorys$forE;
          e.is_integral_value = type;
          (_e$sub_categorys = e.sub_categorys) === null || _e$sub_categorys === void 0 ? void 0 : (_e$sub_categorys$forE = _e$sub_categorys.forEach) === null || _e$sub_categorys$forE === void 0 ? void 0 : _e$sub_categorys$forE.call(_e$sub_categorys, function (el) {
            el.is_integral_value = type;
          });
        });
        _this60.gift_menus.forEach(function (e) {
          e.is_integral_value = type;
        });
      });
    }
  },
  computed: {
    // 是否标准卡规则（报价单场景，功能菜单/基本规则只读）
    isStandardRule: function isStandardRule() {
      return this.cardRuleKind === 'standard';
    },
    // 实际可编辑卡规则：有编辑权限且非标准卡规则
    canEditRule: function canEditRule() {
      return this.hasEditRule && !this.isStandardRule;
    },
    // 交付信息查看/编辑权限：待办入口免权限
    hasDeliveryAuth: function hasDeliveryAuth() {
      return this.deliveryAuthFree || this.$hasBtnRoles('/orders/order/base-info');
    },
    hasEditRule: function hasEditRule() {
      // 是否拥有编辑订单规则权限
      // 客服工作台  客服工作台 vp审核9999 不能操作只能查看
      return this.entryType !== 'platformQueryManage' && this.$hasBtnRoles('/orders/order/admin-set-order-rule') && this.cardBinGroupId != 9999;
    },
    otherMaxRule: function otherMaxRule() {
      var rule = [];
      var not_movie_menu = this.menuList.find(function (i) {
        return i.type !== 'movie';
      });
      if (not_movie_menu) {
        rule = [{
          required: true,
          message: '积分价值必须为大于0的正数！',
          trigger: 'change'
        }, {
          pattern: /^(?!0+$)([1-9]\d*|\d+\.\d+)$/,
          message: '积分价值必须为大于0的正数！',
          trigger: 'change'
        }];
      }
      return rule;
    },
    showLogBtn: function showLogBtn() {
      var menuAuth = {
        orderDetails: '/orders/order/log-list',
        // 订单列表-订单详情-订单规则
        specialCardTypeManage: '/orders/new-card-rule-log/log-list',
        // 代理运营-代理卡类型管理-使用规则
        saleCardTypeManage: '/orders/new-card-rule-log/log-list',
        // 销售工具-卡类型管理-使用规则
        channelCardTypeManage: '/orders/new-card-rule-log/log-list',
        // 管理中心-卡类型管理-使用规则
        standardCardType: '/orders/plat-new-card-rule-log/log-list',
        // 平台配置-标准卡类型-使用规则
        channelCardType: '/orders/channel-new-card-rule-log/log-list',
        // 渠道-配置-卡类型配置-使用规则
        platformQueryManage: '/plat/order/channel-rule-log',
        // 平台客服-使用规则
        serviceCenter: '/orders/order/channel-rule-log' // 客服中心-使用规则
      };
      return !this.hideLogTab && Object.keys(menuAuth).includes(this.menuType) && this.$hasBtnRoles(menuAuth[this.menuType]);
    },
    toFixedRate: function toFixedRate() {
      // return this.integralForm.integral_value_rate
      return this.integralForm.integral_value_rate ? parseFloat(this.integralForm.integral_value_rate).toFixed(2) : this.integralForm.integral_value_rate;
    }
  }
};